import {
  ComponentConfig,
  ComponentType,
  DrawerMenuConfig,
  LayoutTypes,
  ScreenGroupComponent,
  SummaryListActionConfig,
  SummaryListComponent,
  FieldVisibilityRule,
} from "../../services/types/ComponentTypes";
import {
  normalizeCreditDebitNoteSplitRow,
  isCreditNoteInvoiceSubmoduleLookup,
  isCreditNoteInvoiceSplitSubmoduleConfig,
  creditNoteSplitApiRowsAreMeaningful,
  mapCreditNoteSplitApiRows,
  CREDIT_NOTE_INVOICE_SPLIT_BIND,
  applyCreditNoteNetAmountToSplitRows,
  isCreditNoteSplitApiRowPersisted,
} from "../../utils/creditDebitNoteUtils";
import { toDateTimeInputValue } from "../../utils/dateUtils";
import { apiService } from "../../services/api";
import { authService } from "../../services/auth";
import { screen_100_home } from "../../config/100_home";
import { screen_2217_emp_profile } from "../../config/2217_emp_profile";
import { screen_101_vehicles } from "../../config/101_vehicles";
import { screen_102_add_vehicle } from "../../config/102_add_vehicle";
import { screen_103_inspection } from "../../config/103_inspection";
import { screen_104_job_card } from "../../config/104_job_card";
import { screen_105_products } from "../../config/105_products";
import { screen_106_add_product } from "../../config/106_add_product";
import { screen_107_add_inspection } from "../../config/107_add_inspection";
import { screen_108_employee } from "../../config/108_employee";
import { screen_109_parts_request } from "../../config/109_parts_request";
import { screen_110_employee_group } from "../../config/110_employee_group";
import { screen_111_labour_others } from "../../config/111_labour_others";
import { screen_112_stock } from "../../config/112_stock";
import { screen_113_parts_issue } from "../../config/113_parts_issue";
import { screen_114_customers } from "../../config/114_customers";
import { screen_115_parts_return } from "../../config/115_parts_return";
import { screen_116_add_estimate } from "../../config/116_add_estimate";
import { screen_117_invoices } from "../../config/117_invoices";
import { screen_118_sales_return_voucher } from "../../config/118_sales_return_voucher";
import { screen_119_add_labour_others } from "../../config/119_add_labour_others";
import { screen_120_add_parts_issue } from "../../config/120_add_parts_issue";
import { screen_121_add_parts_return } from "../../config/121_add_parts_return";
import { screen_122_add_employee } from "../../config/122_add_employee";
import { screen_123_add_customer } from "../../config/123_add_customer";
import { screen_124_add_sales_return_voucher } from "../../config/124_add_sales_return_voucher";
import { screen_125_purchase_return_voucher } from "../../config/125_purchase_return_voucher";
import { screen_126_add_purchase_return_voucher } from "../../config/126_add_purchase_return_voucher";
import { screen_127_vendors } from "../../config/127_vendors";
import { screen_128_add_vendor } from "../../config/128_add_vendor";
import { screen_129_purchase_order } from "../../config/129_purchase_order";
import { screen_130_add_purchase_order } from "../../config/130_add_purchase_order";
import { screen_131_cash_and_bank } from "../../config/131_cash_and_bank";
import { screen_24_account_flow } from "../../config/24_account_flow";
import { screen_132_charts_of_accounts } from "../../config/132_charts_of_accounts";
import { screen_133_heads_balance_add_for_chart_of_accounts_head } from "../../config/133_heads_balance_add_for_chart_of_accounts_head";
import { screen_134_account_heads } from "../../config/134_account_heads";
import { screen_135_heads_add } from "../../config/135_heads_add";
import { screen_136_head_name } from "../../config/136_head_name";
import { screen_137_head_name_add } from "../../config/137_head_name_add";
import { screen_138_purchase } from "../../config/138_purchase";
import { screen_139_add_purchase } from "../../config/139_add_purchase";
import { screen_140_add_purchase_with_order } from "../../config/140_add_purchase_with_order";
import { screen_141_purchase_return } from "../../config/141_purchase_return";
import { screen_142_receipt_summary } from "../../config/142_receipt_summary";
import { screen_143_payments } from "../../config/143_payments";
import { screen_144_add_payment } from "../../config/144_add_payment";
import { screen_145_payment_summary } from "../../config/145_payment_summary";
import { screen_146_manual_journals } from "../../config/146_manual_journals";
import { screen_147_contra_vouchers } from "../../config/147_contra_vouchers";
import { screen_148_petty_cash_vouchers } from "../../config/148_petty_cash_vouchers";
import { screen_149_cash_payment_vouchers } from "../../config/149_cash_payment_vouchers";
import { screen_150_estimate_approval } from "../../config/150_estimate_approval";
import { screen_27_accounting_years } from "../../config/27_accounting_years";
import { screen_28_accounting_year_mapper } from "../../config/28_accounting_year_mapper";
import { screen_34_ledger_carry_forward } from "../../config/34_ledger_carry_forward";
import { screen_29_journal_voucher } from "../../config/29_journal_voucher";
import { screen_30_receipt_vouchers } from "../../config/30_receipt_vouchers";
import { screen_187_bill_allocations } from "../../config/187_bill_allocations";
import { screen_188_bill_allocations_add } from "../../config/188_bill_allocations_add";
import { screen_189_bill_wise_release } from "../../config/189_bill_wise_release";
import { screen_190_bill_wise_release_add } from "../../config/190_bill_wise_release_add";
import { screen_192_vendor_bill_allocations } from "../../config/192_vendor_bill_allocations";
import { screen_193_vendor_bill_allocations_add } from "../../config/193_vendor_bill_allocations_add";
import { screen_196_bill_allocations_hub } from "../../config/196_bill_allocations_hub";
import { screen_197_bill_release_hub } from "../../config/197_bill_release_hub";
import { screen_194_vendor_bill_wise_release } from "../../config/194_vendor_bill_wise_release";
import { screen_195_vendor_bill_wise_release_add } from "../../config/195_vendor_bill_wise_release_add";
import { screen_186_reference_settlement_summary } from "../../config/186_reference_settlement_summary";
import { screen_200_reference_settlement_view } from "../../config/200_reference_settlement_view";
import { screen_199_reference_settlement_add } from "../../config/199_reference_settlement_add";
import { screen_198_vendor_reference_settlement_add } from "../../config/198_vendor_reference_settlement_add";
import { screen_31_contra_voucher } from "../../config/31_contra_voucher";
import { screen_32_petty_cash_voucher } from "../../config/32_petty_cash_voucher";
import { screen_33_cash_payment_voucher } from "../../config/33_cash_payment_voucher";
import { screen_10_invoice_receivables } from "../../config/10_invoice_receivables";
import { screen_151_vehicle_make } from "../../config/151_vehicle_make";
import { screen_152_vehicle_type } from "../../config/152_vehicle_type";
import { screen_153_lookup_summary } from "../../config/153_lookup_summary";
import { screen_154_branch_summary } from "../../config/154_branch_summary";
import { screen_155_report_summary } from "../../config/155_report_summary";
import { screen_156_jobcard_add } from "../../config/156_jobcard_add";
import { screen_157_qc_approve } from "../../config/157_qc_approve";
import { screen_158_create_invoice } from "../../config/158_create_invoice";
import { screen_159_close_jobcard } from "../../config/159_close_jobcard";
import { screen_160_add_parts_request } from "../../config/160_add_parts_request";
import { screen_161_bank_payment_summary } from "../../config/161_bank_payment_summary";
import { screen_162_bank_payment_voucher } from "../../config/162_bank_payment_voucher";
import { screen_163_credit_note_summary } from "../../config/163_credit_note_summary";
import { screen_164_debit_note_summary } from "../../config/164_debit_note_summary";
import { screen_165_credit_note } from "../../config/165_credit_note";
import { screen_166_debit_note } from "../../config/166_debit_note";
import { screen_167_reports } from "../../config/167_reports";
import { screen_153_lookup_add } from "../../config/153_lookup_add";
import { screen_39_close_jobcard } from "../../config/39_close_jobcard";
import { screen_020_emp_grp_add } from "../../config/020_emp_grp_add";
import { screen_017_itemgroup_add } from "../../config/017_itemgroup_add";
import { screen_168_sales_person } from "../../config/168_sales_person";
import { screen_019_sales_person_add } from "../../config/019_sales_person_add";
import { screen_169_users_summary } from "../../config/169_users_summary";
import { screen_42_users_add } from "../../config/42_users_add";
import { screen_170_branch_add } from "../../config/170_branch_add";
import { screen_171_stock_movement } from "../../config/171_stock_movement";
import { screen_172_batch_summary } from "../../config/172_batch_summary";
import { screen_173_invoice_add_from_summary } from "../../config/173_invoice_add_from_summary";
import { screen_174_proforma_invoice_summary } from "../../config/174_proforma_invoice_summary";
import { screen_175_proforma_invoice_add } from "../../config/175_proforma_invoice_add";

import { hrmAttendanceConfig as screen_2200_attendance_summary } from "../../config/2200_attendance_summary";
import { screen_2201_leave_management_summary } from "../../config/2201_leave_management_summary";
import { screen_2202_leave_add } from "../../config/2202_leave_add";
import { screen_2299_leave_approve_drawer } from "../../config/2299_leave_approve_drawer";
import { screen_2231_payroll_summary } from "../../config/2231_payroll_summary";
import { screen_2236_consolidated_invoice } from "../../config/2236_consolidated_invoice";
import { screen_176_gate_pass_issue } from "../../config/176_gate_pass_issue";
import { screen_177_vat_journal_summary } from "../../config/177_vat_journal_summary";
import { screen_178_vat_journal_add } from "../../config/178_vat_journal_add";
import { screen_179_bank_reconciliation_summary } from "../../config/179_bank_reconciliation_summary";
import { screen_180_bank_reconciliation_voucher } from "../../config/180_bank_reconciliation_voucher";
import { screen_181_bank_reconciliation_register } from "../../config/181_bank_reconciliation_register";
import { screen_191_bank_reconciliation_summary } from "../../config/191_bank_reconciliation_summary";
import { screen_184_jobcard_invoice_auth_request } from "../../config/184_jobcard_invoice_auth_request";
import { screen_185_jobcard_invoice_auth_authorize } from "../../config/185_jobcard_invoice_auth_authorize";
import { screen_181_stock_correction } from "../../config/181_stock_correction";
import { screen_182_stock_correction_add } from "../../config/182_stock_correction_add";
import { screen_2203_emp_summary } from "../../config/2203_emp_summary";
import { screen_2206_emp_grp_summary } from "../../config/2206_emp_grp_summary";
import { screen_2207_emp_grp_add } from "../../config/2207_emp_grp_add";
import { screen_2208_attendance_sessions } from "../../config/2208_attendance_sessions";
import { screen_2226_time_shift_summary } from "../../config/2226_time_shift_summary";
import { screen_2218_holiday_calendar_summary } from "../../config/2218_holiday_calendar_summary";
import { screen_2227_time_shift_add } from "../../config/2227_time_shift_add";
import { screen_2219_holiday_calendar_add } from "../../config/2219_holiday_calendar_add";
import { screen_2220_holiday_calendar_details } from "../../config/2220_holiday_calendar_details";
import { screen_2205_emp_profile_add } from "../../config/2205_emp_profile_add";
import { screen_2224_holiday_add } from "../../config/2224_holiday_add";
import { screen_2225_weekly_off_add } from "../../config/2225_weekly_off_add";
import { screen_2221_holiday_list } from "../../config/2221_holiday_list";
import { screen_2222_holiday_weekly_off } from "../../config/2222_holiday_weekly_off";
import { screen_2235_employee_holiday_calendar_view } from "../../config/2235_employee_holiday_calendar_view";
import { screen_183_account_master } from "../../config/183_account_master";

export const screenConfigRegistry: Record<string, ComponentConfig[]> = {
  "100": screen_100_home,
  "2203": screen_2203_emp_summary,
  "2217": screen_2217_emp_profile,
  "2200": screen_2200_attendance_summary,
  "2208": screen_2208_attendance_sessions,
  "2201": screen_2201_leave_management_summary,
  "2202": screen_2202_leave_add,
  "2212": screen_2299_leave_approve_drawer,
  "2231": screen_2231_payroll_summary,
  "2236": screen_2236_consolidated_invoice,
  "176": screen_176_gate_pass_issue,
  "177": screen_177_vat_journal_summary,
  "178": screen_178_vat_journal_add,
  "179": screen_179_bank_reconciliation_summary,
  "180": screen_180_bank_reconciliation_voucher,
  "191": screen_191_bank_reconciliation_summary,
  "181": screen_181_stock_correction,
  "182": screen_182_stock_correction_add,
  "184": screen_184_jobcard_invoice_auth_request,
  "185": screen_185_jobcard_invoice_auth_authorize,
  "186": screen_186_reference_settlement_summary,
  "200": screen_200_reference_settlement_view,
  "101": screen_101_vehicles,
  "102": screen_102_add_vehicle,
  "103": screen_103_inspection,
  "104": screen_104_job_card,
  "105": screen_105_products,
  "106": screen_106_add_product,
  "107": screen_107_add_inspection,
  "108": screen_108_employee,
  "109": screen_109_parts_request,
  "110": screen_110_employee_group,
  "111": screen_111_labour_others,
  "112": screen_112_stock,
  "113": screen_113_parts_issue,
  "114": screen_114_customers,
  "115": screen_115_parts_return,
  "116": screen_116_add_estimate,
  "117": screen_117_invoices,
  "118": screen_118_sales_return_voucher,
  "119": screen_119_add_labour_others,
  "120": screen_120_add_parts_issue,
  "121": screen_121_add_parts_return,
  "122": screen_122_add_employee,
  "123": screen_123_add_customer,
  "124": screen_124_add_sales_return_voucher,
  "125": screen_125_purchase_return_voucher,
  "126": screen_126_add_purchase_return_voucher,
  "127": screen_127_vendors,
  "128": screen_128_add_vendor,
  "24": screen_24_account_flow,
  "129": screen_129_purchase_order,
  "130": screen_130_add_purchase_order,
  "131": screen_131_cash_and_bank,
  "132": screen_132_charts_of_accounts,
  "133": screen_133_heads_balance_add_for_chart_of_accounts_head,
  "134": screen_134_account_heads,
  "135": screen_135_heads_add,
  "136": screen_136_head_name,
  "137": screen_137_head_name_add,
  "138": screen_138_purchase,
  "139": screen_139_add_purchase,
  "140": screen_140_add_purchase_with_order,
  "141": screen_141_purchase_return,
  "142": screen_142_receipt_summary,
  "143": screen_143_payments,
  "144": screen_144_add_payment,
  "145": screen_145_payment_summary,
  "146": screen_146_manual_journals,
  "147": screen_147_contra_vouchers,
  "148": screen_148_petty_cash_vouchers,
  "149": screen_149_cash_payment_vouchers,
  "150": screen_150_estimate_approval,
  "10": screen_10_invoice_receivables,
  "27": screen_27_accounting_years,
  "28": screen_28_accounting_year_mapper,
  "29": screen_29_journal_voucher,
  "34": screen_34_ledger_carry_forward,
  "30": screen_30_receipt_vouchers,
  "187": screen_187_bill_allocations,
  "188": screen_188_bill_allocations_add,
  "189": screen_189_bill_wise_release,
  "190": screen_190_bill_wise_release_add,
  "192": screen_192_vendor_bill_allocations,
  "193": screen_193_vendor_bill_allocations_add,
  "196": screen_196_bill_allocations_hub,
  "197": screen_197_bill_release_hub,
  "194": screen_194_vendor_bill_wise_release,
  "195": screen_195_vendor_bill_wise_release_add,
  "198": screen_198_vendor_reference_settlement_add,
  "199": screen_199_reference_settlement_add,
  "31": screen_31_contra_voucher,
  "32": screen_32_petty_cash_voucher,
  "33": screen_33_cash_payment_voucher,
  "151": screen_151_vehicle_make,
  "152": screen_152_vehicle_type,
  "153": screen_153_lookup_summary,
  "154": screen_154_branch_summary,
  "155": screen_155_report_summary,
  "156": screen_156_jobcard_add,
  "157": screen_157_qc_approve,
  "158": screen_158_create_invoice,
  "39": screen_39_close_jobcard,
  "159": screen_159_close_jobcard,
  "160": screen_160_add_parts_request,
  "161": screen_161_bank_payment_summary,
  "162": screen_162_bank_payment_voucher,
  "163": screen_163_credit_note_summary,
  "164": screen_164_debit_note_summary,
  "165": screen_165_credit_note,
  "166": screen_166_debit_note,
  "167": screen_167_reports,
  "153_add": screen_153_lookup_add,
  "20": screen_020_emp_grp_add,
  "17": screen_017_itemgroup_add,
  "168": screen_168_sales_person,
  "19": screen_019_sales_person_add,
  "169": screen_169_users_summary,
  "42": screen_42_users_add,
  "170": screen_170_branch_add,
  "171": screen_171_stock_movement,
  "172": screen_172_batch_summary,
  "173": screen_173_invoice_add_from_summary,
  "174": screen_174_proforma_invoice_summary,
  "175": screen_175_proforma_invoice_add,
  "2206": screen_2206_emp_grp_summary,
  "2207": screen_2207_emp_grp_add,
  "2226": screen_2226_time_shift_summary,
  "2218": screen_2218_holiday_calendar_summary,
  "2227": screen_2227_time_shift_add,
  "2219": screen_2219_holiday_calendar_add,
  "2220": screen_2220_holiday_calendar_details,
  "2205": screen_2205_emp_profile_add,
  "2224": screen_2224_holiday_add,
  "2225": screen_2225_weekly_off_add,
  "2221": screen_2221_holiday_list,
  "2222": screen_2222_holiday_weekly_off,
  "2235": screen_2235_employee_holiday_calendar_view,
  "183": screen_183_account_master,
};

export type ConfigSource = 'API' | 'LOCAL' | null;

export interface CachedConfig {
    config: ComponentConfig[];
    source: ConfigSource;
}

/** Last API-fetched config per screen (for save/PDF). Not used to skip API loads. */
export const configCache: Record<string, CachedConfig> = {};

/** Remove cached screen config so the next navigation always hits the API. */
export const clearConfigCache = (screenId?: string): void => {
  if (screenId !== undefined && screenId !== null && String(screenId) !== "") {
    delete configCache[String(screenId)];
    return;
  }
  for (const key of Object.keys(configCache)) {
    delete configCache[key];
  }
};

/**
 * Returns the resolved screen config for a given screenId.
 * Uses the latest API fetch for this screen when available, else static registry.
 */
export const getResolvedScreenConfig = (screenId: string): ComponentConfig[] | undefined => {
    return configCache[screenId]?.config || screenConfigRegistry[screenId];
};

const isSubModuleComponentType = (componentType: unknown): boolean => {
  const ct = String(componentType ?? "").trim().toLowerCase();
  return ct === "submodule" || ct === ComponentType.SUB_MODULE.toLowerCase();
};

/** Recursively collect persisted SUB_MODULE components from any screen layout. */
export const findSubModulesInScreenConfig = (
  components: ComponentConfig[] | undefined
): any[] => {
  const subModules: any[] = [];
  if (!components?.length) return subModules;

  const walk = (comps: ComponentConfig[]) => {
    comps.forEach((comp) => {
      const anyComp = comp as any;
      if (isSubModuleComponentType(anyComp.componentType)) {
        subModules.push(anyComp);
      }
      if (Array.isArray(anyComp.childComponents) && anyComp.childComponents.length > 0) {
        walk(anyComp.childComponents);
      }
      if (Array.isArray(anyComp.Fields) && anyComp.Fields.length > 0) {
        walk(anyComp.Fields);
      }
      if (Array.isArray(anyComp.childControls) && anyComp.childControls.length > 0) {
        walk(anyComp.childControls);
      }
    });
  };

  walk(components);
  return subModules;
};

/**
 * Module settings file name for GET /submodule/{modulename}/...
 * Prefer Name (settings/module/{Name}.json) over TableName — they often differ
 * (e.g. vehiclein_work_requested vs vehicle_work_requested).
 */
export const resolveSubModulePersistedModuleName = (subModule: {
  name?: string;
  Name?: string;
  BindValue?: string;
  tableName?: string;
  TableName?: string;
}): string =>
  String(
    subModule?.Name ||
      subModule?.name ||
      subModule?.TableName ||
      subModule?.tableName ||
      ""
  ).trim();

/** Lookup-driven submodules without a DB table (e.g. pending purchase parts). */
export const isLookupOnlySubModule = (subModule: {
  lookupName?: string;
  LookupName?: string;
  tableName?: string;
  TableName?: string;
  excludeFromSave?: boolean;
}): boolean => {
  // Persistence target is the DB table, not the module JSON file name.
  const tableName = String(
    subModule?.TableName || subModule?.tableName || ""
  ).trim();
  if (tableName) return false;
  const lookup = String(subModule?.lookupName || subModule?.LookupName || "").trim();
  return lookup.length > 0 || subModule?.excludeFromSave === true;
};

export const isParentIdBindValue = (bindValue?: string): boolean =>
  bindValue === "parentid" || bindValue === "parentid1";

/** Resolve LookupName for a field by BindValue/name (e.g. parentid → parts_request_jobcard). */
export const findBindValueLookupName = (
  screenConfig: ComponentConfig[] | undefined,
  bindValue: string
): string | undefined => {
  const target = String(bindValue || "").trim();
  if (!target || !screenConfig?.length) return undefined;
  let lookupName: string | undefined;

  const readLookupFromField = (field: Record<string, unknown>): boolean => {
    const name = String(field.name || field.BindValue || "").trim();
    if (name !== target) return false;
    lookupName =
      String(field.lookupName || field.LookupName || "").trim() || undefined;
    return Boolean(lookupName);
  };

  walkComponentTree(screenConfig, (component) => {
    if (readLookupFromField(component as Record<string, unknown>)) {
      return true;
    }
    const nestedForm = (component as Record<string, unknown>).Form as
      | { Fields?: Record<string, unknown>[] }
      | undefined;
    if (Array.isArray(nestedForm?.Fields)) {
      for (const field of nestedForm.Fields) {
        if (readLookupFromField(field)) return true;
      }
    }
    return false;
  });
  return lookupName;
};

export const viewToScreenIdMap: Record<string, string> = {
  garage: "100",
  vehicle_form: "100",
  vehicles: "101",
  inspection: "103",
  job_card: "104",
  products: "105",
  product: "105",
  product_summary: "105",
  product_add: "106",
  "modulev1/product_add": "106",
  "modulev1/product_add/<id>": "106",
  employee: "108",
  employee_group: "110",
  stock: "112",
  stock_movement: "171",
  batch_summary: "172",
  parts_issue: "113",
  parts_request: "109",
  parts_return: "115",
  customers: "114",
  labour_others: "111",
  invoices: "117",
  sales_return_voucher: "118",
  sales_return_vouchers: "118",
  parts_issue_add: "120",
  parts_issue_add_edit: "120",
  parts_return_add: "121",
  parts_return_add_edit: "121",
  emp_add: "122",
  emp_add_edit: "122",
  customer_add: "123",
  customer_add_edit: "123",
  sales_return_voucher_add: "124",
  sales_return_voucher_add_edit: "124",
  "modulev1/sales_return_add": "124",
  "modulev1/sales_return_add/<id>": "124",
  "modulev1/sales_ret_add": "124",
  "modulev1/sales_ret_add/<id>": "124",
  sales_return_add: "124",
  sales_ret_add: "124",
  sales_return_summary: "118",
  "modulev1/sales_return_summary": "118",
  purchase_return_voucher: "125",
  purchase_return_vouchers: "125",
  purchase_return_voucher_add: "126",
  purchase_return_voucher_add_edit: "126",
  vendors: "127",
  supplier_summary: "127",
  vendor_summary: "127",
  supplier_add: "128",
  supplier_add_edit: "128",
  vendor_add: "128",
  vendor_add_edit: "128",
  purchase_order: "129",
  purchase_orders: "129",
  purchase_order_summary: "129",
  purchase_order_add: "130",
  purchase_order_add_edit: "130",
  cash_and_bank: "131",
  cash_bank: "131",
  accounts_cash_bank: "131",
  account_flow: "24",
  heads_balance_add: "24",
  "modulev1/heads_balance_add": "24",
  "modulev1/ledgers": "131",
  charts_of_accounts: "132",
  "modulev1/charts_of_accounts": "132",
  account_master: "183",
  accounts_account_master: "183",
  "accounts/account-master": "183",
  "modulev1/heads_balance_add_for_chart_of_accounts_head": "133",
  account_heads: "134",
  heads: "134",
  "modulev1/account_heads": "134",
  "modulev1/heads": "134",
  "modulev1/heads_summary": "134",
  heads_add: "135",
  "modulev1/heads_add": "135",
  "modulev1/sub_group_summary": "136",
  sub_group_summary: "136",
  head_name: "136",
  "modulev1/head_name": "136",
  "modulev1/heads_sub_group_add": "137",
  heads_sub_group_add: "137",
  head_name_add: "137",
  "modulev1/accounting_years_summary": "27",
  accounting_years_summary: "27",
  "modulev1/accounting_year_mapper": "28",
  accounting_year_mapper: "28",
  "modulev1/accounting_year_mapper_summary": "27",
  accounting_year_mapper_summary: "27",
  "modulev1/ledger_carry_forward": "34",
  ledger_carry_forward: "34",
  "modulev1/receivables_summary": "30",
  receivables_summary: "30",
  "modulev1/bill_allocations_hub": "196",
  bill_allocations_hub: "196",
  "modulev1/bill_allocations_summary": "187",
  bill_allocations_summary: "187",
  "modulev1/bill_allocations": "188",
  "modulev1/bill_allocations/<id>": "188",
  bill_allocations: "188",
  "modulev1/bill_release_hub": "197",
  bill_release_hub: "197",
  "modulev1/bill_wise_release_summary": "189",
  bill_wise_release_summary: "189",
  "modulev1/bill_wise_release": "190",
  "modulev1/bill_wise_release/<id>": "190",
  bill_wise_release: "190",
  "modulev1/vendor_bill_allocations_summary": "192",
  vendor_bill_allocations_summary: "192",
  "modulev1/vendor_bill_allocations": "193",
  "modulev1/vendor_bill_allocations/<id>": "193",
  vendor_bill_allocations: "193",
  "modulev1/vendor_bill_wise_release_summary": "194",
  vendor_bill_wise_release_summary: "194",
  "modulev1/vendor_bill_wise_release": "195",
  "modulev1/vendor_bill_wise_release/<id>": "195",
  vendor_bill_wise_release: "195",
  "modulev1/reference_settlement_summary": "186",
  reference_settlement_summary: "186",
  "modulev1/reference_settlement_view": "200",
  reference_settlement_view: "200",
  "modulev1/reference_settlement": "199",
  "modulev1/reference_settlement/<id>": "199",
  reference_settlement: "199",
  "modulev1/vendor_reference_settlement": "198",
  "modulev1/vendor_reference_settlement/<id>": "198",
  vendor_reference_settlement: "198",
  receipt_vouchers: "30",
  "modulev1/invoice_receivables": "10",
  invoice_receivables: "10",
  "modulev1/purchase_summary": "138",
  purchase_summary: "138",
  "modulev1/purchase_add_without_order": "139",
  purchase_add_without_order: "139",
  "modulev1/purchase_add": "140",
  purchase_add: "140",
  "modulev1/purchase_return_summary": "141",
  purchase_return_summary: "141",
  "modulev1/purchase_return_add": "126",
  "modulev1/purchase_return_add/<id>": "126",
  purchase_return_add: "126",
  "modulev1/pur_ret_add": "126",
  "modulev1/pur_ret_add/<id>": "126",
  pur_ret_add: "126",
  "modulev1/receipt_summary": "142",
  receipt_summary: "142",
  credit_summary: "142",
  "modulev1/payment_summary": "145",
  payment_summary: "145",
  payments: "143",
  "modulev1/payment_add": "144",
  payment_add: "144",
  "modulev1/payments_summary": "145",
  payments_summary: "145",
  "modulev1/manual_journals": "146",
  manual_journals: "146",
  journal_voucher_summary: "146",
  "modulev1/journal_voucher": "29",
  journal_voucher: "29",
  "modulev1/vat_journal": "178",
  "modulev1/vat_journal/<id>": "178",
  vat_journal: "178",
  vat_journal_summary: "177",
  "modulev1/vat_journal_summary": "177",
  "modulev1/contra_vouchers": "147",
  "modulev1/contra_voucher_summary": "147",
  contra_vouchers: "147",
  contra_voucher_summary: "147",
  "modulev1/contra_voucher": "31",
  "modulev1/contra_voucher/<id>": "31",
  contra_voucher: "31",
  "modulev1/petty_cash_vouchers": "148",
  petty_cash_vouchers: "148",
  petty_cash_voucher_summary: "148",
  "modulev1/petty_voucher_summary": "148",
  "modulev1/petty_cash_voucher": "32",
  "modulev1/petty_cash_voucher/<id>": "32",
  petty_cash_voucher: "32",
  "modulev1/cash_payment_vouchers": "149",
  cash_payment_vouchers: "149",
  cash_payment_voucher_summary: "149",
  "modulev1/cash_payment_voucher_summary": "149",
  "modulev1/cash_payment_voucher": "33",
  "modulev1/cash_payment_voucher/<id>": "33",
  cash_payment_voucher: "33",
  "modulev1/bank_payment_voucher_summary": "161",
  "modulev1/bank_payment_vouchers": "161",
  bank_payment_voucher_summary: "161",
  bank_payment_vouchers: "161",
  bank_payment_summary: "161",
  vehicle_make: "151",
  "modulev1/vehiclemake": "151",
  "screen/vehiclemake": "151",
  vehicle_type: "152",
  "modulev1/vehicletype": "152",
  "screen/vehicletype": "152",
  lookup_summary: "153",
  "modulev1/lookup_summary": "153",
  branch_summary: "154",
  "modulev1/branch_summary": "154",
  report_summary: "155",
  "modulev1/report_summary": "155",
  jobcard_add: "156",
  "modulev1/jobcard_add": "156",
  "modulev1/jobcard_add/<id>": "156",
  "modulev1/qc_approve": "157",
  "modulev1/qc_approve/<id>": "157",
  invoice_add: "158",
  "modulev1/invoice_add": "158",
  "modulev1/invoice_add/<id>": "158",
  "modulev1/parts_request_add": "160",
  "modulev1/parts_request_add/<id>": "160",
  "modulev1/close_jobcard": "39",
  "modulev1/close_jobcard/<id>": "39",
  "modulev1/bank_payment_voucher": "162",
  "modulev1/bank_payment_voucher/<id>": "162",
  "modulev1/bank_reconciliation_voucher_summary": "179",
  "modulev1/bank_reconciliation_vouchers": "179",
  bank_reconciliation_voucher_summary: "179",
  bank_reconciliation_vouchers: "179",
  "modulev1/bank_reconciliation_voucher": "180",
  "modulev1/bank_reconciliation_voucher/<id>": "180",
  bank_reconciliation_voucher: "180",
  stock_correction: "181",
  "modulev1/stock_correction": "181",
  stock_correction_summary: "181",
  "modulev1/stock_correction_summary": "181",
  stock_correction_add: "182",
  "modulev1/stock_correction_add": "182",
  "modulev1/stock_correction_add/<id>": "182",
  "modulev1/pdc_reminder_summary": "179",
  pdc_reminder_summary: "179",
  "modulev1/bank_reconciliation_summary": "191",
  bank_reconciliation_summary: "191",
  "modulev1/bank_reconciliation_register": "181",
  bank_reconciliation_register: "181",
  "modulev1/bank_reconciliation_voucher_register": "181",
  bank_reconciliation_voucher_register: "181",
  "modulev1/jobcard_invoice_auth_request": "184",
  jobcard_invoice_auth_request: "184",
  "modulev1/jobcard_invoice_auth_request_summary": "184",
  jobcard_invoice_auth_request_summary: "184",
  "modulev1/jobcard_invoice_auth_authorize": "185",
  jobcard_invoice_auth_authorize: "185",
  "modulev1/jobcard_invoice_auth_authorize_summary": "185",
  jobcard_invoice_auth_authorize_summary: "185",
  "modulev1/credit_note_summary": "163",
  credit_note_summary: "163",
  "credit-note-summary": "163",
  "vouchers/credit-note-summary": "163",
  "modulev1/debit_note_summary": "164",
  debit_note_summary: "164",
  "debit-note-summary": "164",
  "vouchers/debit-note-summary": "164",
  "modulev1/credit_note": "165",
  "modulev1/credit_note/<id>": "165",
  credit_note: "165",
  "modulev1/debit_note": "166",
  "modulev1/debit_note/<id>": "166",
  debit_note: "166",
  // Reports
  reports: "167",
  "modulev1/reports": "167",
  "modulev1/ReportModule": "167",
  report_module: "167",
  lookup_add: "153_add",
  "modulev1/lookup_add/<id>": "153_add",
  "modulev1/emp_grp_add": "20",
  "modulev1/emp_grp_add/<id>": "20",
  emp_grp_add: "20",
  itemgroup_add: "17",
  "modulev1/itemgroup_add": "17",
  "modulev1/itemgroup_add/<id>": "17",
  ItemGroup_Add: "17",
  emp_grp_summary: "110",
  "modulev1/emp_grp_summary": "110",
  "modulev1/sales_person_summary": "168",
  "modulev1/sales_person_add": "19",
  "modulev1/sales_person_add/<id>": "19",
  "user_summary": "169",
  "modulev1/user_summary": "169",
  "modulev1/users_add": "42",
  "modulev1/users_add/<id>": "42",
  "modulev1/branch_add": "170",
  branch_add: "170",
  "modulev1/invoice_add_from_summary": "173",
  invoice_add_from_summary: "173",
  "modulev1/proforma_invoice_summary": "174",
  proforma_invoice_summary: "174",
  "modulev1/proforma_invoice_add": "175",
  proforma_invoice_add: "175",
  "modulev1/proforma_invoice_add/<id>": "175",
  leave_management: "2201",
  // HRMS Leave screens (API configs commonly use these view/action ids)
  leave_management_summary: "2201",
  leave_add: "2202",
  leave_approve_reject: "2212",
  payroll_summary: "2231",
  consolidated_invoice: "2236",
  "modulev1/consolidated_invoice": "2236",
  "modulev1/gate_pass_issue": "176",
  "time_shift_summary": "2226",
  "modulev1/time_shift_summary": "2226",
  "holiday_calendar_summary": "2218",
  "modulev1/holiday_calendar_summary": "2218",
  "time_shift_add": "2227",
  "modulev1/time_shift_add": "2227",
  "modulev1/time_shift_add/<id>": "2227",
  "holiday_calendar_add": "2219",
  "modulev1/holiday_calendar_add": "2219",
  "modulev1/holiday_calendar_add/<id>": "2219",
  "holiday_calendar_details": "2220",
  "modulev1/holiday_calendar_details": "2220",
  "modulev1/holiday_calendar_details/<id>": "2220",
  "hrm/holiday_calendar_details": "2220",
  "hrm/holiday_calendar_details/<id>": "2220",
  "emp_profile_add": "2205",
  "emp_profile_add/<id>": "2205",
  "modulev1/emp_profile_add": "2205",
  "modulev1/emp_profile_add/<id>": "2205",
  "hrm/employee_edit": "2205",
  "hrm/employee_edit/<id>": "2205",
  "hrm/emp_grp_add": "2207",
  "hrm/emp_grp_add/<id>": "2207",
  "holiday_add": "2224",
  "modulev1/holiday_add": "2224",
  "modulev1/holiday_add/<id>": "2224",
  "hrm/holiday_add": "2224",
  "hrm/holiday_add/<id>": "2224",
  "weekly_off_add": "2225",
  "modulev1/weekly_off_add": "2225",
  "modulev1/weekly_off_add/<id>": "2225",
  "hrm/weekly_off_add": "2225",
  "hrm/weekly_off_add/<id>": "2225",
  "holiday_list": "2221",
  "modulev1/holiday_list": "2221",
  "hrm/holiday_list": "2221",
  "holiday_weekly_off": "2222",
  "modulev1/holiday_weekly_off": "2222",
  "hrm/holiday_weekly_off": "2222",
  "hrm/holiday_calendar_add": "2219",
  "hrm/holiday_calendar_add/<id>": "2219",
};

/** Normalize a view string to the API name used for GET /pabws/screen/{name} */
const normalizeViewToScreenApiName = (view: string): string =>
  view
    .replace(/^modulev1\//, "")
    .replace(/\/<id>.*$/, "")
    .replace(/\/<id>/, "")
    .split("/")[0] || view;

/**
 * Map screenId -> canonical API name for GET /pabws/screen/{name}.
 * Built from viewToScreenIdMap; prefers view names containing "summary" or "_add".
 */
export const screenIdToScreenApiName: Record<string, string> = (() => {
  const byScreenId: Record<string, string[]> = {};
  for (const [view, screenId] of Object.entries(viewToScreenIdMap)) {
    if (!byScreenId[screenId]) byScreenId[screenId] = [];
    byScreenId[screenId].push(view);
  }
  const map: Record<string, string> = {};
  for (const [screenId, views] of Object.entries(byScreenId)) {
    const preferred = views.find(
      (v) =>
        v.includes("summary") ||
        v.includes("_add") ||
        v.includes("_summary")
    );
    const view = preferred ?? views[0];
    map[screenId] = normalizeViewToScreenApiName(view);
  }
  return map;
})();

/**
 * Returns the API name to use for the screen-load call GET /pabws/screen/{name}.
 * 1. SCREEN_GROUP.loadApiName if set in config
 * 2. currentView normalized (if not purely numeric)
 * 3. screenIdToScreenApiName[screenId]
 */
export const getScreenApiName = (
  screenId: string,
  config?: ComponentConfig[],
  currentView?: string
): string | undefined => {
  const screenGroup = config?.find(
    (c) => c.componentType === LayoutTypes.SCREEN_GROUP
  ) as ScreenGroupComponent | undefined;
  if (screenGroup?.loadApiName) {
    return screenGroup.loadApiName;
  }
  if (currentView && currentView.trim() && !/^\d+$/.test(currentView.trim())) {
    return normalizeViewToScreenApiName(currentView);
  }
  return screenIdToScreenApiName[screenId];
};

const inputComponentTypes: ComponentType[] = [
  ComponentType.TEXT_FIELD,
  ComponentType.TEXT_AREA,
  ComponentType.SELECT_DROPDOWN,
  ComponentType.SEARCHABLE_DROPDOWN,
  ComponentType.RADIO_FIELD,
  ComponentType.DATE_FIELD,
  ComponentType.DATETIME_FIELD,
  ComponentType.IMAGE_UPLOAD,
  ComponentType.MULTI_CHECKBOX,
  ComponentType.CHECKBOX,
];

const coerceCheckboxFormValue = (value: unknown): boolean => {
  if (value === true || value === 1 || value === "1") return true;
  if (value === false || value === 0 || value === "0") return false;
  const s = String(value ?? "").trim().toLowerCase();
  return s === "true" || s === "yes" || s === "on";
};

type RecordFieldMapContext = {
  findMappedValueForField: (bindKey?: string, jsonKey?: string) => unknown;
  findValueInBase: (key: string) => unknown;
  screenId?: string;
};

const mapBindFieldFromRecord = (
  fieldConfig: { componentType?: ComponentType },
  bindValue: string,
  jsonAttr: string,
  mapped: Record<string, unknown>,
  ctx: RecordFieldMapContext
) => {
  let value = ctx.findMappedValueForField(bindValue, jsonAttr);

  if (
    ctx.screenId === "150" &&
    (isParentIdBindValue(bindValue) || jsonAttr === "parent_id")
  ) {
    const idValue = ctx.findValueInBase("id");
    if (idValue !== undefined && idValue !== null) {
      value = idValue;
    }
  }

  if (value === undefined || value === null) return;

  if (
    (fieldConfig.componentType === ComponentType.DATE_FIELD ||
      fieldConfig.componentType === ComponentType.DATETIME_FIELD) &&
    typeof value === "string"
  ) {
    mapped[bindValue] = formatDateForInput(value);
    if (jsonAttr !== bindValue) {
      mapped[jsonAttr] = mapped[bindValue];
    }
    return;
  }

  if (fieldConfig.componentType === ComponentType.CHECKBOX) {
    const checked = coerceCheckboxFormValue(value);
    mapped[bindValue] = checked;
    if (jsonAttr !== bindValue) {
      mapped[jsonAttr] = checked ? 1 : 0;
    }
    return;
  }

  mapped[bindValue] = value;
  if (jsonAttr !== bindValue) {
    mapped[jsonAttr] = value;
  }
};

const walkAndMapChildFields = (
  fields: any[],
  mapped: Record<string, unknown>,
  ctx: RecordFieldMapContext
) => {
  fields.forEach((field) => {
    const bindValue = field.BindValue;
    const jsonAttr = field.Json_Attribute || field.json_Attribute;
    if (bindValue && jsonAttr && field.componentType) {
      mapBindFieldFromRecord(field, bindValue, jsonAttr, mapped, ctx);
    }
    if (field.childComponents && Array.isArray(field.childComponents)) {
      walkAndMapChildFields(field.childComponents, mapped, ctx);
    }
  });
};

/** Resolve main form + DB table for save (API screen JSON may omit TableName). */
export const resolveFormForSave = (
  screenConfig: ComponentConfig[] | undefined,
  screenId?: string
): {
  formComponent: ComponentConfig | null;
  tableName: string;
  moduleEndpoint: string;
} => {
  let formComponent: ComponentConfig | null = null;
  let tableName = "";
  let moduleEndpoint = "";

  const readForm = (config: ComponentConfig[] | undefined) => {
    walkComponentTree(config, (component) => {
      if (component.componentType !== LayoutTypes.FORM) {
        return false;
      }
      formComponent = component;
      const anyForm = component as unknown as Record<string, unknown>;
      tableName = String(anyForm.TableName || anyForm.tableName || "").trim();
      moduleEndpoint = String(anyForm.Name || anyForm.name || "").trim() || tableName;
      return true;
    });
  };

  readForm(screenConfig);
  if ((!formComponent || !tableName) && screenId) {
    readForm(screenConfigRegistry[screenId]);
  }
  if (formComponent && !tableName && moduleEndpoint) {
    tableName = moduleEndpoint;
  }
  return { formComponent, tableName, moduleEndpoint };
};

export const walkComponentTree = (
  components: ComponentConfig[] | undefined,
  visitor: (component: ComponentConfig) => boolean | void
) => {
  if (!components) {
    return;
  }

  for (const component of components) {
    const shouldStop = visitor(component);
    if (shouldStop) {
      return;
    }

    const childComponents = (component as any).childComponents as
      | ComponentConfig[]
      | undefined;
    if (childComponents && childComponents.length > 0) {
      walkComponentTree(childComponents, visitor);
    }

    const childControls = (component as any).childControls as
      | ComponentConfig[]
      | undefined;
    if (childControls && childControls.length > 0) {
      walkComponentTree(childControls, visitor);
    }

    // Also traverse Fields property (used by FORM components)
    const fields = (component as any).Fields as
      | ComponentConfig[]
      | undefined;
    if (fields && fields.length > 0) {
      walkComponentTree(fields, visitor);
    }
  }
};

export const summaryActionsMatch = (
  a: SummaryListActionConfig,
  b: SummaryListActionConfig
): boolean => {
  if (a === b) return true;
  const aType = String(a.ActionType ?? "")
    .trim()
    .toLowerCase();
  const bType = String(b.ActionType ?? "")
    .trim()
    .toLowerCase();
  if (aType !== bType) return false;

  const aNav = String(a.Action?.Navigate ?? a.Action?.navigate ?? "").trim();
  const bNav = String(b.Action?.Navigate ?? b.Action?.navigate ?? "").trim();
  const aMod = String(a.Action?.Module ?? a.Action?.module ?? "").trim();
  const bMod = String(b.Action?.Module ?? b.Action?.module ?? "").trim();

  if (aNav && bNav && aNav !== bNav) return false;
  if (aMod && bMod && aMod !== bMod) return false;
  return true;
};

export const findSummaryListByAction = (
  targetAction: SummaryListActionConfig
): SummaryListComponent | null => {
  const screenIds = new Set([
    ...Object.keys(screenConfigRegistry),
    ...Object.keys(configCache),
  ]);

  for (const screenId of screenIds) {
    const components = getResolvedScreenConfig(screenId);
    let found: SummaryListComponent | null = null;

    walkComponentTree(components, (component) => {
      if (component.componentType === ComponentType.SUMMARY_LIST) {
        const summaryComponent = component as SummaryListComponent;
        if (
          summaryComponent.SummeryActions?.some((action) =>
            summaryActionsMatch(action, targetAction)
          )
        ) {
          found = summaryComponent;
          return true;
        }
      }
      return false;
    });

    if (found) {
      return found;
    }
  }

  return null;
};

export const collectFieldNamesForScreen = (screenId: string): Set<string> => {
  const fieldNames = new Set<string>();
  const components = getResolvedScreenConfig(screenId);

  if (!components) {
    return fieldNames;
  }

  walkComponentTree(components, (component) => {
    if (
      inputComponentTypes.includes(component.componentType as ComponentType)
    ) {
      const fieldName = (component as any).name;
      if (fieldName) {
        fieldNames.add(fieldName);
      }
    }
    return false;
  });

  return fieldNames;
};

export const resolveUserCode = (
  decryptedData: Record<string, any> | null | undefined
): string | undefined => {
  if (!decryptedData) {
    return undefined;
  }

  const candidates = [
    decryptedData.usercode,
    decryptedData.empCode,
    decryptedData.userCode,
    decryptedData.empId,
    decryptedData.userId,
    decryptedData.loginName,
    decryptedData.userName,
  ];

  for (const candidate of candidates) {
    if (candidate !== undefined && candidate !== null) {
      const value = String(candidate).trim();
      if (value) {
        return value;
      }
    }
  }

  return undefined;
};

const generateGuid = (): string => {
  const globalCrypto =
    typeof globalThis !== "undefined"
      ? (globalThis.crypto as Crypto | undefined)
      : undefined;

  if (globalCrypto?.randomUUID) {
    return globalCrypto.randomUUID();
  }

  if (globalCrypto?.getRandomValues) {
    const buffer = new Uint8Array(16);
    globalCrypto.getRandomValues(buffer);
    buffer[6] = (buffer[6] & 0x0f) | 0x40;
    buffer[8] = (buffer[8] & 0x3f) | 0x80;
    const hex = Array.from(buffer, (b) => b.toString(16).padStart(2, "0"));
    return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex
      .slice(6, 8)
      .join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10, 16).join("")}`;
  }

  let timestamp = Date.now();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = (timestamp + Math.random() * 16) % 16 | 0;
    timestamp = Math.floor(timestamp / 16);
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
};

const formatDateForId = (date: Date): string => {
  return `${date.getFullYear().toString().slice(-2)}${String(
    date.getMonth() + 1
  ).padStart(2, "0")}${String(date.getDate()).padStart(2, "0")}${String(
    date.getHours()
  ).padStart(2, "0")}${String(date.getMinutes()).padStart(2, "0")}${String(
    date.getSeconds()
  ).padStart(2, "0")}${String(date.getMilliseconds()).padStart(3, "0")}`;
};

export const generateUniqueFormId = (
  userCode?: string | number,
  instance?: number
): string => {
  const id = generateGuid().replace(/-/g, "");
  const normalizedUserCode = userCode
    ? String(userCode).trim().replace(/\s+/g, "").toUpperCase()
    : "UNKNOWN";
  const timestamp = formatDateForId(new Date());
  const instanceSegment = instance && instance > 0 ? instance : 1;

  return `${id}_${normalizedUserCode}_${timestamp}_${instanceSegment}`;
};

/**
 * Format date from backend/form format to HTML input format.
 * Naive API ISO is treated as UTC via toDateTimeInputValue / parseApiDate.
 *
 * Output: "2024-01-15T10:30" (local) or "2024-01-15" for date-only.
 */
export const formatDateForInput = (dateString: string | null | undefined): string => {
  if (!dateString || typeof dateString !== "string" || dateString.trim() === "") {
    return "";
  }

  try {
    const trimmed = dateString.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      return trimmed;
    }
    return toDateTimeInputValue(trimmed);
  } catch {
    return "";
  }
};

/** Coerce subform row field / multicheckbox stored value to a scalar string (handles nested objects). */
const coerceSubformSelectionId = (val: any, jsonAttr: string): string => {
  if (val === null || val === undefined) return "";
  if (typeof val === "object") {
    const o = val as Record<string, any>;
    const inner = o[jsonAttr] ?? o.id ?? o.value ?? o.codeid ?? "";
    if (inner !== null && inner !== undefined && typeof inner === "object") {
      return coerceSubformSelectionId(inner, jsonAttr);
    }
    return inner === null || inner === undefined ? "" : String(inner);
  }
  return String(val);
};

const bindValueIsMissingOrEmpty = (v: any): boolean => {
  if (v === undefined || v === null) return true;
  if (Array.isArray(v)) return v.length === 0;
  if (typeof v === "string") return v.trim() === "";
  return false;
};

/** Coerce sales-return line numeric fields to strings for grid inputs (incl. 0). */
export const normalizeSalesReturnSubmoduleRow = (
  row: Record<string, any>
): Record<string, any> => {
  const r: Record<string, any> = { ...row };
  const numericKeys = [
    "return_qty",
    "txt_return_qty",
    "return_net_amt",
    "txt_return_net_amt",
    "inv_qty",
    "txt_inv_qty",
    "rate",
    "txt_rate",
    "amount",
    "txt_amount",
    "vat_amt",
    "txt_vat_amt",
    "net_amt",
    "txt_net_amt",
    "unit_discount",
    "txt_unit_discount",
    "line_discount",
    "txt_line_discount",
  ];
  for (const key of numericKeys) {
    const v = r[key];
    if (v !== undefined && v !== null && v !== "") {
      r[key] = String(v);
    }
  }
  if (
    (r.txt_return_qty === undefined ||
      r.txt_return_qty === null ||
      r.txt_return_qty === "") &&
    r.return_qty !== undefined &&
    r.return_qty !== null &&
    r.return_qty !== ""
  ) {
    r.txt_return_qty = String(r.return_qty);
  }
  if (
    (r.return_qty === undefined ||
      r.return_qty === null ||
      r.return_qty === "") &&
    r.txt_return_qty !== undefined &&
    r.txt_return_qty !== null &&
    r.txt_return_qty !== ""
  ) {
    r.return_qty = String(r.txt_return_qty);
  }
  if (
    (r.txt_return_net_amt === undefined ||
      r.txt_return_net_amt === null ||
      r.txt_return_net_amt === "") &&
    r.return_net_amt !== undefined &&
    r.return_net_amt !== null &&
    r.return_net_amt !== ""
  ) {
    r.txt_return_net_amt = String(r.return_net_amt);
  }
  if (
    (r.return_net_amt === undefined ||
      r.return_net_amt === null ||
      r.return_net_amt === "") &&
    r.txt_return_net_amt !== undefined &&
    r.txt_return_net_amt !== null &&
    r.txt_return_net_amt !== ""
  ) {
    r.return_net_amt = String(r.txt_return_net_amt);
  }
  if (
    (r.txt_src_line_id === undefined ||
      r.txt_src_line_id === null ||
      r.txt_src_line_id === "") &&
    r.src_line_id !== undefined &&
    r.src_line_id !== null &&
    r.src_line_id !== ""
  ) {
    r.txt_src_line_id = String(r.src_line_id);
  }
  if (
    (r.src_line_id === undefined ||
      r.src_line_id === null ||
      r.src_line_id === "") &&
    r.txt_src_line_id !== undefined &&
    r.txt_src_line_id !== null &&
    r.txt_src_line_id !== ""
  ) {
    r.src_line_id = String(r.txt_src_line_id);
  }
  return r;
};

/** After loading purchase invoice lines, keep original qty in inv_qty and start return qty at 0. */
export const applyPurchaseReturnInvoiceTemplateRow = (
  row: Record<string, any>,
  lookupItem?: Record<string, any>
): Record<string, any> => {
  const purchaseQty =
    lookupItem?.inv_qty ??
    lookupItem?.qty ??
    row.inv_qty ??
    row.txt_inv_qty ??
    row.qty ??
    row.txt_qty;
  const inv =
    purchaseQty !== undefined && purchaseQty !== null && purchaseQty !== ""
      ? String(purchaseQty)
      : "0";
  const issuedSrc =
    lookupItem?.issued_qty ??
    lookupItem?.txt_issued_qty ??
    row.issued_qty ??
    row.txt_issued_qty ??
    "0";
  const returnableSrc =
    lookupItem?.returnable_qty ??
    lookupItem?.txt_returnable_qty ??
    row.returnable_qty ??
    row.txt_returnable_qty;
  const issued =
    issuedSrc !== undefined && issuedSrc !== null && issuedSrc !== ""
      ? String(issuedSrc)
      : "0";
  let returnable =
    returnableSrc !== undefined && returnableSrc !== null && returnableSrc !== ""
      ? String(returnableSrc)
      : "";
  if (returnable === "") {
    const invN = Number(inv) || 0;
    const issuedN = Number(issued) || 0;
    returnable = String(Math.max(0, invN - issuedN));
  }
  return {
    ...row,
    inv_qty: inv,
    txt_inv_qty: inv,
    issued_qty: issued,
    txt_issued_qty: issued,
    returnable_qty: returnable,
    txt_returnable_qty: returnable,
    qty: "0",
    txt_qty: "0",
    amount: "0",
    txt_amount: "0",
    vat_amt: "0",
    txt_vat_amt: "0",
    net_amt: "0",
    txt_net_amt: "0",
  };
};

/** Coerce purchase-return line numeric fields to strings for grid inputs (incl. 0). */
export const normalizePurchaseReturnSubmoduleRow = (
  row: Record<string, any>
): Record<string, any> => {
  const r: Record<string, any> = { ...row };
  const numericKeys = [
    "qty",
    "txt_qty",
    "inv_qty",
    "txt_inv_qty",
    "issued_qty",
    "txt_issued_qty",
    "returnable_qty",
    "txt_returnable_qty",
    "rate",
    "txt_rate",
    "amount",
    "txt_amount",
    "vat_amt",
    "txt_vat_amt",
    "net_amt",
    "txt_net_amt",
  ];
  for (const key of numericKeys) {
    const v = r[key];
    if (v !== undefined && v !== null && v !== "") {
      r[key] = String(v);
    }
  }
  if (
    (r.txt_qty === undefined || r.txt_qty === null || r.txt_qty === "") &&
    r.qty !== undefined &&
    r.qty !== null &&
    r.qty !== ""
  ) {
    r.txt_qty = String(r.qty);
  }
  if (
    (r.inv_qty === undefined || r.inv_qty === null || r.inv_qty === "") &&
    r.txt_inv_qty !== undefined &&
    r.txt_inv_qty !== null &&
    r.txt_inv_qty !== ""
  ) {
    r.inv_qty = String(r.txt_inv_qty);
  }
  if (
    (r.txt_inv_qty === undefined || r.txt_inv_qty === null || r.txt_inv_qty === "") &&
    r.inv_qty !== undefined &&
    r.inv_qty !== null &&
    r.inv_qty !== ""
  ) {
    r.txt_inv_qty = String(r.inv_qty);
  }
  if (
    (r.issued_qty === undefined || r.issued_qty === null || r.issued_qty === "") &&
    r.txt_issued_qty !== undefined &&
    r.txt_issued_qty !== null &&
    r.txt_issued_qty !== ""
  ) {
    r.issued_qty = String(r.txt_issued_qty);
  }
  if (
    (r.txt_issued_qty === undefined ||
      r.txt_issued_qty === null ||
      r.txt_issued_qty === "") &&
    r.issued_qty !== undefined &&
    r.issued_qty !== null &&
    r.issued_qty !== ""
  ) {
    r.txt_issued_qty = String(r.issued_qty);
  }
  if (
    (r.returnable_qty === undefined ||
      r.returnable_qty === null ||
      r.returnable_qty === "") &&
    r.txt_returnable_qty !== undefined &&
    r.txt_returnable_qty !== null &&
    r.txt_returnable_qty !== ""
  ) {
    r.returnable_qty = String(r.txt_returnable_qty);
  }
  if (
    (r.txt_returnable_qty === undefined ||
      r.txt_returnable_qty === null ||
      r.txt_returnable_qty === "") &&
    r.returnable_qty !== undefined &&
    r.returnable_qty !== null &&
    r.returnable_qty !== ""
  ) {
    r.txt_returnable_qty = String(r.returnable_qty);
  }
  if (
    (r.qty === undefined || r.qty === null || r.qty === "") &&
    r.txt_qty !== undefined &&
    r.txt_qty !== null &&
    r.txt_qty !== ""
  ) {
    r.qty = String(r.txt_qty);
  }
  if (
    (r.txt_product === undefined || r.txt_product === null) &&
    r.product_id !== undefined &&
    r.product_id !== null &&
    r.product_id !== ""
  ) {
    r.drp_product = r.drp_product ?? r.product_id;
  }
  if (
    (r.product_id === undefined || r.product_id === null || r.product_id === "") &&
    r.drp_product !== undefined &&
    r.drp_product !== null &&
    r.drp_product !== ""
  ) {
    r.product_id = r.drp_product;
  }
  return r;
};

/**
 * Rows from GET /submodule with return qty/net — not purchase invoice template rows.
 */
export const hasPersistedSubModuleRows = (rows: unknown): boolean => {
  if (!Array.isArray(rows) || rows.length === 0) return false;
  return rows.some((r) => {
    if (!r || typeof r !== "object") return false;
    const row = r as Record<string, any>;

    const rq = Number(row.return_qty ?? row.txt_return_qty);
    if (!Number.isNaN(rq) && rq > 0) return true;
    const rna = Number(row.return_net_amt ?? row.txt_return_net_amt);
    if (!Number.isNaN(rna) && rna > 0) return true;
    const hasReturnFields =
      (row.return_qty !== undefined && row.return_qty !== null) ||
      (row.txt_return_qty !== undefined && row.txt_return_qty !== null) ||
      (row.return_net_amt !== undefined && row.return_net_amt !== null) ||
      (row.txt_return_net_amt !== undefined && row.txt_return_net_amt !== null);

    const pq = Number(row.qty ?? row.txt_qty);
    const pnet = Number(row.net_amt ?? row.txt_net_amt);
    const hasPurchaseReturnFields =
      (row.qty !== undefined && row.qty !== null) ||
      (row.txt_qty !== undefined && row.txt_qty !== null) ||
      (row.net_amt !== undefined && row.net_amt !== null) ||
      (row.txt_net_amt !== undefined && row.txt_net_amt !== null);

    const lineId = row.id;

    if (
      hasReturnFields &&
      lineId !== undefined &&
      lineId !== null &&
      String(lineId).trim() !== ""
    ) {
      return true;
    }

    if (
      hasPurchaseReturnFields &&
      lineId !== undefined &&
      lineId !== null &&
      String(lineId).trim() !== ""
    ) {
      return (!Number.isNaN(pq) && pq > 0) || (!Number.isNaN(pnet) && pnet > 0);
    }

    const parentId = row.parent_id ?? row.parentid;
    const invoiceNo = String(row.invoice_no ?? row.txt_invoice_no ?? "").trim();
    const purchaseNo = String(row.purchase_no ?? row.txt_purchase_no ?? "").trim();
    if (
      parentId !== undefined &&
      parentId !== null &&
      String(parentId).trim() !== "" &&
      (invoiceNo !== "" || purchaseNo !== "")
    ) {
      return true;
    }

    const splitAmount = row.amount ?? row.txt_amount;
    if (
      (invoiceNo !== "" || purchaseNo !== "") &&
      splitAmount !== undefined &&
      splitAmount !== null &&
      String(splitAmount).trim() !== "" &&
      lineId !== undefined &&
      lineId !== null &&
      String(lineId).trim() !== ""
    ) {
      return true;
    }

    return false;
  });
};

/** Overlay saved purchase-return qty/amounts onto purchase invoice template rows (edit mode). */
export const mergePurchaseReturnSavedRows = (
  displayRows: Record<string, any>[],
  savedRows: Record<string, any>[]
): Record<string, any>[] => {
  if (!savedRows?.length) {
    return Array.isArray(displayRows)
      ? displayRows.map((r) => normalizePurchaseReturnSubmoduleRow(r))
      : [];
  }
  if (!displayRows?.length) {
    return savedRows.map((r) => normalizePurchaseReturnSubmoduleRow(r));
  }

  const savedByProduct = new Map<string, Record<string, any>>();
  for (const s of savedRows) {
    const norm = normalizePurchaseReturnSubmoduleRow(s);
    const key = String(norm.product_id ?? norm.drp_product ?? "").trim();
    if (key) savedByProduct.set(key, norm);
  }

  const pickField = (...candidates: unknown[]) => {
    for (const v of candidates) {
      if (v === 0 || v === "0") return v;
      if (v !== undefined && v !== null && v !== "") return v;
    }
    return candidates[candidates.length - 1];
  };

  return displayRows.map((invRow) => {
    const key = String(invRow.product_id ?? invRow.drp_product ?? "").trim();
    const saved = key ? savedByProduct.get(key) : undefined;
    if (!saved) {
      return normalizePurchaseReturnSubmoduleRow(
        applyPurchaseReturnInvoiceTemplateRow(invRow)
      );
    }
    const invQty = pickField(
      invRow.inv_qty,
      invRow.txt_inv_qty,
      invRow.qty,
      invRow.txt_qty,
      "0"
    );
    const issuedQty = pickField(
      invRow.issued_qty,
      invRow.txt_issued_qty,
      "0"
    );
    const savedQty = pickField(saved.qty, saved.txt_qty, "0");
    const lookupReturnable = pickField(
      invRow.returnable_qty,
      invRow.txt_returnable_qty,
      null
    );
    let returnableQty = lookupReturnable;
    if (returnableQty === null || returnableQty === undefined || returnableQty === "") {
      const invN = Number(invQty) || 0;
      const issuedN = Number(issuedQty) || 0;
      returnableQty = String(Math.max(0, invN - issuedN));
    } else {
      // Lookup subtracts this voucher's posted qty; add it back for edit.
      const retN = Number(returnableQty) || 0;
      const savedN = Number(savedQty) || 0;
      returnableQty = String(retN + savedN);
    }
    return normalizePurchaseReturnSubmoduleRow({
      ...invRow,
      ...saved,
      id: saved.id ?? invRow.id,
      product_id: pickField(saved.product_id, saved.drp_product, invRow.product_id, invRow.drp_product),
      drp_product: pickField(saved.drp_product, saved.product_id, invRow.drp_product, invRow.product_id),
      inv_qty: invQty,
      txt_inv_qty: invQty,
      issued_qty: issuedQty,
      txt_issued_qty: issuedQty,
      returnable_qty: returnableQty,
      txt_returnable_qty: returnableQty,
      qty: savedQty,
      txt_qty: pickField(saved.txt_qty, saved.qty, "0"),
      amount: pickField(saved.amount, saved.txt_amount, invRow.amount, invRow.txt_amount),
      txt_amount: pickField(saved.txt_amount, saved.amount, invRow.txt_amount, invRow.amount),
      vat_amt: pickField(saved.vat_amt, saved.txt_vat_amt, invRow.vat_amt, invRow.txt_vat_amt),
      txt_vat_amt: pickField(saved.txt_vat_amt, saved.vat_amt, invRow.txt_vat_amt, invRow.vat_amt),
      net_amt: pickField(saved.net_amt, saved.txt_net_amt, invRow.net_amt, invRow.txt_net_amt),
      txt_net_amt: pickField(saved.txt_net_amt, saved.net_amt, invRow.txt_net_amt, invRow.net_amt),
    });
  });
};

/** Overlay saved sales-return line return qty/net onto invoice template rows (edit mode). */
export const mergeSalesReturnSavedRows = (
  displayRows: Record<string, any>[],
  savedRows: Record<string, any>[]
): Record<string, any>[] => {
  if (!savedRows?.length) {
    return Array.isArray(displayRows)
      ? displayRows.map((r) => normalizeSalesReturnSubmoduleRow(r))
      : [];
  }
  if (!displayRows?.length) {
    return savedRows.map((r) => normalizeSalesReturnSubmoduleRow(r));
  }

  const savedBySrc = new Map<string, Record<string, any>>();
  for (const s of savedRows) {
    const norm = normalizeSalesReturnSubmoduleRow(s);
    const key = String(norm.src_line_id ?? norm.txt_src_line_id ?? "").trim();
    if (key) savedBySrc.set(key, norm);
  }

  return displayRows.map((invRow) => {
    const key = String(invRow.txt_src_line_id ?? invRow.src_line_id ?? "").trim();
    const saved = key ? savedBySrc.get(key) : undefined;
    if (!saved) return normalizeSalesReturnSubmoduleRow(invRow);
    const pickReturnField = (...candidates: unknown[]) => {
      for (const v of candidates) {
        if (v === 0 || v === "0") return v;
        if (v !== undefined && v !== null && v !== "") return v;
      }
      return candidates[candidates.length - 1];
    };
    return normalizeSalesReturnSubmoduleRow({
      ...invRow,
      ...saved,
      id: saved.id ?? invRow.id,
      src_line_id: pickReturnField(
        saved.src_line_id,
        saved.txt_src_line_id,
        invRow.src_line_id,
        invRow.txt_src_line_id
      ),
      txt_src_line_id: pickReturnField(
        saved.txt_src_line_id,
        saved.src_line_id,
        invRow.txt_src_line_id,
        invRow.src_line_id
      ),
      return_qty: pickReturnField(
        saved.return_qty,
        saved.txt_return_qty,
        invRow.return_qty,
        invRow.txt_return_qty
      ),
      txt_return_qty: pickReturnField(
        saved.txt_return_qty,
        saved.return_qty,
        invRow.txt_return_qty,
        invRow.return_qty
      ),
      return_net_amt: pickReturnField(
        saved.return_net_amt,
        saved.txt_return_net_amt,
        invRow.return_net_amt,
        invRow.txt_return_net_amt
      ),
      txt_return_net_amt: pickReturnField(
        saved.txt_return_net_amt,
        saved.return_net_amt,
        invRow.txt_return_net_amt,
        invRow.return_net_amt
      ),
    });
  });
};

/** Sync voucher detail row keys for edit display/save (BindValue + Json_Attribute). */
export const normalizeVoucherDetailSubModuleRow = (
  row: Record<string, any>
): Record<string, any> => {
  if (!row || typeof row !== "object") return row;
  const r: Record<string, any> = { ...row };
  const syncPair = (bindKey: string, jsonKey: string) => {
    const b = r[bindKey];
    const j = r[jsonKey];
    if ((b === undefined || b === null || b === "") && j !== undefined && j !== null && j !== "") {
      r[bindKey] = j;
    }
    if ((j === undefined || j === null || j === "") && b !== undefined && b !== null && b !== "") {
      r[jsonKey] = b;
    }
  };
  syncPair("drp_from_ledger", "ledger_id");
  syncPair("drp_to_ledger", "to_ledger");
  syncPair("drp_ledger", "to_ledger");
  syncPair("drp_vat", "vat_id");
  syncPair("txt_to_narration", "to_narration");
  syncPair("txt_remarks", "remarks");
  syncPair("txt_amount", "amount");
  syncPair("txt_credit", "credit");
  if (r.id && !r.act) {
    r.act = "edit";
  }
  return r;
};

export const VOUCHER_DETAIL_SUBMODULE_KEYS = [
  "voucher_details",
  "contra_voucher_details",
  "petty_cash_voucher_details",
];

/** @deprecated Use VOUCHER_DETAIL_SUBMODULE_KEYS */
export const CONTRA_VOUCHER_DETAIL_SUBMODULE_KEYS = VOUCHER_DETAIL_SUBMODULE_KEYS;

export const isVoucherDetailSubModule = (
  subModule: {
    name?: string;
    Name?: string;
    BindValue?: string;
    tableName?: string;
    TableName?: string;
  },
  parentModuleName?: string
): boolean => {
  const parent = String(parentModuleName || "").toLowerCase();
  if (
    parent === "contra_voucher" ||
    parent === "petty_cash_voucher" ||
    parent === "journal_voucher"
  ) {
    return true;
  }
  const table = String(
    subModule?.tableName || subModule?.TableName || ""
  ).toLowerCase();
  if (table === "voucher_details") {
    return true;
  }
  const name = String(
    subModule?.name || subModule?.Name || subModule?.BindValue || ""
  ).toLowerCase();
  return VOUCHER_DETAIL_SUBMODULE_KEYS.includes(name);
};

/** @deprecated Use isVoucherDetailSubModule */
export const isContraVoucherDetailSubModule = isVoucherDetailSubModule;

/** Normalize petty cash (screen 32) API settings for edit load and save. */
export const applyPettyCashVoucherScreenHotfixes = (
  config: ComponentConfig[]
): ComponentConfig[] => {
  const patched = JSON.parse(JSON.stringify(config)) as ComponentConfig[];

  walkComponentTree(patched, (component) => {
    const ct = String(component.componentType || "").toLowerCase();
    const anyComp = component as any;

    if (ct === "fieldgroup" || ct === LayoutTypes.FIELD_GROUP) {
      const bind = String(anyComp.BindValue || anyComp.bindValue || "");
      if (bind === "petty_cash_voucher_details") {
        anyComp.BindValue = "petty_cash_voucher_header";
        anyComp.bindValue = "petty_cash_voucher_header";
      }
    }

    if (ct === "submodule" || ct === ComponentType.SUB_MODULE) {
      const name = String(anyComp.name || anyComp.Name || "").toLowerCase();
      const bind = String(anyComp.BindValue || anyComp.bindValue || "").toLowerCase();
      const isPettyCashLines =
        name === "petty_cash_voucher_details" ||
        bind === "petty_cash_voucher_details";
      if (!isPettyCashLines) {
        return false;
      }
      anyComp.name = "voucher_details";
      anyComp.Name = "voucher_details";
      anyComp.BindValue = "voucher_details";
      anyComp.bindValue = "voucher_details";
      anyComp.lookupName = "";
      anyComp.LookupName = "";
      delete anyComp.parentField;
      delete anyComp.Parent_Field;
      delete anyComp.parentfield;
    }

    return false;
  });

  return patched;
};

/** Store submodule rows under every bind key the UI may read (name/BindValue + contra aliases). */
export const assignSubModuleRowsToFormData = (
  formData: Record<string, any>,
  subModule: { name?: string; Name?: string; BindValue?: string },
  rows: Record<string, any>[],
  parentModuleName?: string
): void => {
  const keys = new Set<string>();
  const add = (value?: string) => {
    const trimmed = String(value || "").trim();
    if (trimmed) keys.add(trimmed);
  };
  add(subModule?.name || subModule?.Name);
  add(subModule?.BindValue);
  if (isVoucherDetailSubModule(subModule, parentModuleName)) {
    VOUCHER_DETAIL_SUBMODULE_KEYS.forEach((key) => keys.add(key));
  }
  keys.forEach((key) => {
    formData[key] = rows;
  });
};

/** Load submodule rows; contra vouchers may use legacy module name contra_voucher_details. */
export const fetchSubModuleRowsForEdit = async (
  getSubModuleData: (name: string, recordId: string | number) => Promise<any[]>,
  subModule: {
    name?: string;
    Name?: string;
    BindValue?: string;
    tableName?: string;
    TableName?: string;
    lookupName?: string;
    LookupName?: string;
    excludeFromSave?: boolean;
  },
  recordId: string | number,
  parentModuleName?: string
): Promise<any[]> => {
  if (isLookupOnlySubModule(subModule)) {
    return [];
  }

  const primary =
    resolveSubModulePersistedModuleName(subModule) ||
    String(subModule?.name || subModule?.Name || subModule?.BindValue || "").trim();
  if (!primary) return [];

  const moduleCandidates = [primary];
  const tableName = String(
    subModule?.tableName || subModule?.TableName || ""
  ).trim();
  const moduleName = String(
    subModule?.Name || subModule?.name || ""
  ).trim();
  // Name and TableName often differ; try both so ModuleLoader finds settings/module/*.json
  for (const alias of [moduleName, tableName]) {
    if (alias && !moduleCandidates.includes(alias)) {
      moduleCandidates.push(alias);
    }
  }
  if (tableName === CREDIT_NOTE_INVOICE_SPLIT_BIND) {
    for (const alias of ["invoice_recivebles", CREDIT_NOTE_INVOICE_SPLIT_BIND]) {
      if (!moduleCandidates.includes(alias)) {
        moduleCandidates.push(alias);
      }
    }
  }
  if (isVoucherDetailSubModule(subModule, parentModuleName)) {
    VOUCHER_DETAIL_SUBMODULE_KEYS.forEach((alias) => {
      if (!moduleCandidates.includes(alias)) {
        moduleCandidates.push(alias);
      }
    });
  }

  for (const moduleName of moduleCandidates) {
    const rows = await getSubModuleData(moduleName, recordId);
    if (!Array.isArray(rows) || rows.length === 0) continue;
    if (tableName === CREDIT_NOTE_INVOICE_SPLIT_BIND) {
      if (
        creditNoteSplitApiRowsAreMeaningful(rows) ||
        rows.some((row) => isCreditNoteSplitApiRowPersisted(row))
      ) {
        return rows;
      }
      continue;
    }
    return rows;
  }
  return [];
};

/** Map GET /submodule rows onto SubModule childControl BindValue keys for edit display. */
export const mapSubModuleApiRowsToFormRows = (
  subModule: {
    childControls?: any[];
    ChildControls?: any[];
    name?: string;
    Name?: string;
    BindValue?: string;
  },
  apiRows: any[]
): Record<string, any>[] => {
  if (!Array.isArray(apiRows) || apiRows.length === 0) return [];
  const controls = subModule?.childControls || subModule?.ChildControls;
  const splitLookupName =
    (subModule as any)?.lookupName || (subModule as any)?.LookupName || null;
  const tableName = String(
    (subModule as any)?.tableName || (subModule as any)?.TableName || ""
  ).toLowerCase();
  if (
    tableName === "invoice_recivebles_split" &&
    isCreditNoteInvoiceSubmoduleLookup(splitLookupName)
  ) {
    const mapped = mapCreditNoteSplitApiRows(apiRows, splitLookupName, controls);
    return mapped;
  }
  const subName = String(
    subModule?.name || subModule?.Name || subModule?.BindValue || ""
  ).toLowerCase();
  const isCreditDebitSplitTable =
    tableName === "invoice_recivebles_split" ||
    tableName === "purchase_payment_split";
  const isSalesReturnLine = subName.startsWith("sales_return_");
  const isPurchaseReturnLine = subName === "purchase_return_details";
  if (!Array.isArray(controls) || controls.length === 0) {
    return apiRows.map((row) => {
      if (isSalesReturnLine) return normalizeSalesReturnSubmoduleRow({ ...row });
      if (isPurchaseReturnLine) return normalizePurchaseReturnSubmoduleRow({ ...row });
      if (isVoucherDetailSubModule(subModule)) {
        return normalizeVoucherDetailSubModuleRow({ ...row });
      }
      if (isCreditDebitSplitTable) {
        return normalizeCreditDebitNoteSplitRow({ ...row }, splitLookupName);
      }
      return { ...row };
    });
  }
  return apiRows.map((item) => {
    const row: Record<string, any> = { ...item };
    for (const control of controls) {
      const fieldName = control.name || control.BindValue;
      const jsonAttr = control.Json_Attribute;
      if (!fieldName || !jsonAttr) continue;

      let value =
        item[jsonAttr] ??
        item[String(jsonAttr).toLowerCase()] ??
        item[fieldName];

      if (value === undefined || value === null) continue;

      row[fieldName] = value;
      row[jsonAttr] = value;

      const desc =
        item[`${jsonAttr}_desc`] ??
        item[`${fieldName}_desc`];
      if (desc !== undefined && desc !== null && String(desc).trim() !== "") {
        row[`${jsonAttr}_desc`] = desc;
        row[`${fieldName}_desc`] = desc;
      }
    }
    if (
      item.taxrate !== undefined &&
      item.taxrate !== null &&
      String(item.taxrate).trim() !== "" &&
      (row.taxrate === undefined ||
        row.taxrate === null ||
        String(row.taxrate).trim() === "")
    ) {
      row.taxrate = item.taxrate;
    }
    if (isSalesReturnLine) return normalizeSalesReturnSubmoduleRow(row);
    if (isPurchaseReturnLine) return normalizePurchaseReturnSubmoduleRow(row);
    if (isVoucherDetailSubModule(subModule)) {
      return normalizeVoucherDetailSubModuleRow(row);
    }
    if (isCreditDebitSplitTable) {
      return normalizeCreditDebitNoteSplitRow(row, splitLookupName);
    }
    // Invoice line tables: persisted rows must save as act=edit, not add.
    if (isInvoiceLineSubModuleTable(tableName) || isInvoiceLineSubModuleTable(subName)) {
      if (row.id && (!row.act || row.act === "add")) {
        row.act = "edit";
      }
    }
    return row;
  });
};

/** Whether a submodule row is marked for soft deletion. */
export const isSubModuleRowSoftDeleted = (
  row: Record<string, any> | null | undefined
): boolean => {
  if (!row) return false;
  return (
    row.soft_delete === 1 ||
    row.soft_delete === "1" ||
    row.soft_delete === true
  );
};

/** Invoice line child tables (Create Invoice / Invoice module). */
export const INVOICE_LINE_SUBMODULE_TABLES = new Set([
  "service_invoice_spareparts",
  "service_invoice_labour",
  "service_invoice_miscellaneous",
]);

export const isInvoiceLineSubModuleTable = (
  tableOrName: string | null | undefined
): boolean =>
  INVOICE_LINE_SUBMODULE_TABLES.has(
    String(tableOrName || "")
      .trim()
      .toLowerCase()
  );

/**
 * Identity key for matching an invoice line across form ↔ DB.
 * Spare/labour: product/code id.
 * Misc: item_name only — item_type is a dropdown and often id-vs-label/empty
 * mismatch between estimation seed and saved invoice rows, which caused
 * kept misc lines to save as act=add (duplicates) on edit.
 */
export const invoiceLineIdentityKey = (
  row: Record<string, any> | null | undefined,
  tableName?: string
): string => {
  if (!row || typeof row !== "object") return "";
  const table = String(tableName || "").toLowerCase();
  if (table === "service_invoice_miscellaneous") {
    const itemName = String(
      row.item_name ?? row.txt_item_name ?? row.txt_itemname ?? ""
    ).trim();
    if (!itemName) return "";
    return `misc:${itemName}`.toLowerCase();
  }
  const code =
    row.codeid ??
    row.drp_code ??
    row.code ??
    row.product_id ??
    "";
  const codeStr = String(code).trim();
  return codeStr ? `code:${codeStr}` : "";
};

/**
 * On invoice edit save: match form lines to existing DB lines by product identity
 * (act=edit + reuse id), and soft-delete DB lines missing from the submit payload.
 * Estimation-seeded rows often carry non-invoice ids — those are stripped unless they
 * match a real invoice line id from `existingDbRows`.
 */
export const reconcileInvoiceLineRowsForEditSave = (
  formRows: Record<string, any>[] | null | undefined,
  existingDbRows: any[] | null | undefined,
  tableName: string
): Record<string, any>[] => {
  const table = String(tableName || "").toLowerCase();
  const activeDb = (Array.isArray(existingDbRows) ? existingDbRows : []).filter(
    (r) => r && !isSubModuleRowSoftDeleted(r) && getPersistedSubModuleRowId(r)
  );

  const byId = new Map<string, any>();
  const identityQueues = new Map<string, string[]>();

  for (const db of activeDb) {
    const id = getPersistedSubModuleRowId(db);
    byId.set(id, db);
    const key = invoiceLineIdentityKey(db, table);
    if (!key) continue;
    const queue = identityQueues.get(key) || [];
    queue.push(id);
    identityQueues.set(key, queue);
  }

  const claimedIds = new Set<string>();
  const emittedActiveIdentityKeys = new Set<string>();
  const out: Record<string, any>[] = [];

  const removeFromIdentityQueue = (key: string, id: string) => {
    const queue = identityQueues.get(key);
    if (!queue) return;
    const idx = queue.indexOf(id);
    if (idx >= 0) queue.splice(idx, 1);
  };

  const pushActive = (row: Record<string, any>, identityKey: string) => {
    if (identityKey && emittedActiveIdentityKeys.has(identityKey)) {
      // Same misc/product already kept active in this payload — do not insert a twin.
      return;
    }
    if (identityKey) emittedActiveIdentityKeys.add(identityKey);
    out.push(row);
  };

  for (const row of Array.isArray(formRows) ? formRows : []) {
    if (!row || typeof row !== "object") continue;
    const soft = isSubModuleRowSoftDeleted(row);
    const rowId = getPersistedSubModuleRowId(row);

    if (soft) {
      if (rowId && byId.has(rowId) && !claimedIds.has(rowId)) {
        claimedIds.add(rowId);
        removeFromIdentityQueue(
          invoiceLineIdentityKey(byId.get(rowId), table),
          rowId
        );
        out.push({ ...row, id: rowId, act: "edit", soft_delete: 1 });
        continue;
      }
      // Soft-deleted form row with a foreign/estimation id (or no invoice id):
      // still soft-delete the matching DB line by product/item identity.
      const softKey = invoiceLineIdentityKey(row, table);
      if (softKey) {
        const queue = identityQueues.get(softKey) || [];
        while (queue.length > 0) {
          const candidate = queue.shift()!;
          if (claimedIds.has(candidate)) continue;
          claimedIds.add(candidate);
          const dbRow = byId.get(candidate);
          out.push({
            ...(dbRow || {}),
            ...row,
            id: candidate,
            act: "edit",
            soft_delete: 1,
            parent_id: row.parent_id ?? dbRow?.parent_id,
          });
          break;
        }
      }
      continue;
    }

    if (rowId && byId.has(rowId) && !claimedIds.has(rowId)) {
      claimedIds.add(rowId);
      const idKey =
        invoiceLineIdentityKey(row, table) ||
        invoiceLineIdentityKey(byId.get(rowId), table);
      removeFromIdentityQueue(idKey, rowId);
      pushActive(
        {
          ...row,
          id: rowId,
          act: "edit",
          parent_id: row.parent_id ?? byId.get(rowId)?.parent_id,
        },
        idKey
      );
      continue;
    }

    const key = invoiceLineIdentityKey(row, table);
    let matchedId = "";
    if (key) {
      const queue = identityQueues.get(key) || [];
      while (queue.length > 0) {
        const candidate = queue.shift()!;
        if (!claimedIds.has(candidate)) {
          matchedId = candidate;
          break;
        }
      }
    }

    if (matchedId) {
      claimedIds.add(matchedId);
      pushActive(
        {
          ...row,
          id: matchedId,
          act: "edit",
          parent_id: row.parent_id ?? byId.get(matchedId)?.parent_id,
        },
        key
      );
      continue;
    }

    // New line — drop foreign ids (estimation / lookup) so save generates a fresh id.
    const next: Record<string, any> = { ...row, act: "add" };
    if (rowId && !byId.has(rowId)) {
      delete next.id;
      delete next.itemid;
      delete next.src_line_id;
      delete next.txt_src_line_id;
    }
    pushActive(next, key);
  }

  for (const db of activeDb) {
    const id = getPersistedSubModuleRowId(db);
    if (!id || claimedIds.has(id)) continue;
    out.push({
      ...db,
      id,
      soft_delete: 1,
      act: "edit",
      parent_id: db.parent_id,
    });
  }

  return out;
};

/** Persisted line id used for subform save / soft-delete (not lookup product ids). */
export const getPersistedSubModuleRowId = (
  row: Record<string, any> | null | undefined
): string => {
  if (!row || typeof row !== "object") return "";
  for (const key of ["id", "itemid", "src_line_id", "txt_src_line_id"]) {
    const value = row[key];
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      return String(value).trim();
    }
  }
  return "";
};

/**
 * Keep MULTI_CHECKBOX submodule rows as objects (persisted id + lookup id),
 * matching MULTI_SUB_LIST edit behavior so saves can use act "edit".
 * Duplicate lookup ids (from prior always-add saves) are kept once; extras are
 * marked soft_delete so the next save can clean them up.
 */
export const mapMultiCheckboxApiRowsToFormRows = (
  rows: any[],
  jsonAttr: string = "work_requested_id"
): Record<string, any>[] => {
  if (!Array.isArray(rows)) return [];
  const out: Record<string, any>[] = [];
  for (const row of rows) {
    if (row == null) continue;
    if (typeof row !== "object") {
      const lookupId = String(row).trim();
      if (!lookupId || lookupId === "[object Object]") continue;
      out.push({ [jsonAttr]: lookupId, act: "add" });
      continue;
    }
    if (
      row.soft_delete === 1 ||
      row.soft_delete === "1" ||
      row.soft_delete === true
    ) {
      continue;
    }
    // Never fall back to row.id — that is the persisted child row id, not the lookup id.
    const lookupId = coerceSubformSelectionId(
      row[jsonAttr] ?? row.value,
      jsonAttr
    );
    if (!lookupId || lookupId === "[object Object]") continue;
    const persistedId = getPersistedSubModuleRowId(row);
    const mapped: Record<string, any> = {
      ...row,
      [jsonAttr]: lookupId,
    };
    if (persistedId) {
      mapped.id = persistedId;
      if (!mapped.act || mapped.act === "add") {
        mapped.act = "edit";
      }
    }
    out.push(mapped);
  }

  // Collapse duplicate lookup selections; soft-delete extras on next save.
  const keptByLookup = new Map<string, Record<string, any>>();
  const softDeleteExtras: Record<string, any>[] = [];
  for (const row of out) {
    const lookupId = String(row[jsonAttr] ?? "");
    if (!lookupId) continue;
    const existing = keptByLookup.get(lookupId);
    if (!existing) {
      keptByLookup.set(lookupId, row);
      continue;
    }
    const existingId = getPersistedSubModuleRowId(existing);
    const rowId = getPersistedSubModuleRowId(row);
    if (rowId && rowId !== existingId) {
      softDeleteExtras.push({ ...row, soft_delete: 1, act: "edit" });
    }
  }
  return [...keptByLookup.values(), ...softDeleteExtras];
};

/** Row loaded from API in edit mode even when top-level `id` was lost from the object. */
export const isPersistedSubModuleRowForEdit = (
  row: Record<string, any>,
  parentRecordId?: string | number | null
): boolean => {
  if (getPersistedSubModuleRowId(row)) return true;
  const parentId = String(parentRecordId ?? "").trim();
  if (!parentId) return false;
  const rowParentId = String(row.parent_id ?? row.parentid ?? "").trim();
  const hasParent = rowParentId !== "" && rowParentId === parentId;
  const hasCreatedAt =
    row.created_at !== undefined &&
    row.created_at !== null &&
    String(row.created_at).trim() !== "";
  return hasParent && hasCreatedAt;
};

const submoduleRowMergeScore = (row: Record<string, any>): number => {
  let score = 0;
  if (isSubModuleRowSoftDeleted(row)) score += 10;
  const act = String(row.act ?? "").toLowerCase();
  if (act === "edit" || act === "delete") score += 5;
  return score;
};

/** Stable fingerprint for new (no persisted id) rows so alias-key clones do not double on save. */
const submoduleNoIdRowSignature = (row: Record<string, any>): string => {
  const skip = new Set([
    "id",
    "itemid",
    "src_line_id",
    "txt_src_line_id",
    "act",
    "_action",
    "action",
    "created_at",
    "created_by",
    "modified_at",
    "modified_by",
    "soft_delete",
  ]);
  const parts: string[] = [];
  for (const key of Object.keys(row).sort()) {
    if (skip.has(key) || key.endsWith("_selectedData") || key.endsWith("_desc")) {
      continue;
    }
    const value = row[key];
    if (value === undefined || value === null) continue;
    if (typeof value === "object") continue;
    parts.push(`${key}=${String(value).trim()}`);
  }
  return parts.join("|");
};

/**
 * Merge two submodule row arrays by persisted id; prefer soft-deleted / edited copies.
 * New rows (no id) come from primary in full (allows intentional identical lines). Secondary
 * no-id rows are included only when they are not content-clones of primary — fixes purchase
 * save doubling when BindValue (jobcard_details) and name (purchase_details) both hold copies.
 */
export const mergeSubmoduleRowsById = (
  primary: Record<string, any>[],
  secondary: Record<string, any>[]
): Record<string, any>[] => {
  if (primary === secondary) {
    return Array.isArray(primary) ? [...primary] : [];
  }

  const merged = new Map<string, Record<string, any>>();
  const noIdRows: Record<string, any>[] = [];
  const seenNoIdRefs = new WeakSet<object>();
  const seenNoIdSignatures = new Set<string>();

  const ingestWithId = (rows: Record<string, any>[]) => {
    for (const row of rows) {
      if (!row || typeof row !== "object") continue;
      const rowId = getPersistedSubModuleRowId(row);
      if (!rowId) continue;
      const existing = merged.get(rowId);
      if (
        !existing ||
        submoduleRowMergeScore(row) >= submoduleRowMergeScore(existing)
      ) {
        merged.set(rowId, existing ? { ...existing, ...row } : { ...row });
      }
    }
  };

  const appendNoIdFromPrimary = (rows: Record<string, any>[]) => {
    for (const row of rows) {
      if (!row || typeof row !== "object") continue;
      if (getPersistedSubModuleRowId(row)) continue;
      if (seenNoIdRefs.has(row)) continue;
      seenNoIdRefs.add(row);
      noIdRows.push(row);
      const sig = submoduleNoIdRowSignature(row);
      if (sig) seenNoIdSignatures.add(sig);
    }
  };

  const appendNoIdFromSecondary = (rows: Record<string, any>[]) => {
    for (const row of rows) {
      if (!row || typeof row !== "object") continue;
      if (getPersistedSubModuleRowId(row)) continue;
      if (seenNoIdRefs.has(row)) continue;
      const sig = submoduleNoIdRowSignature(row);
      // Skip alias clones of primary new rows (same content, different object).
      if (sig && seenNoIdSignatures.has(sig)) continue;
      seenNoIdRefs.add(row);
      if (sig) seenNoIdSignatures.add(sig);
      noIdRows.push(row);
    }
  };

  ingestWithId(primary);
  ingestWithId(secondary);
  appendNoIdFromPrimary(primary);
  appendNoIdFromSecondary(secondary);
  return [...merged.values(), ...noIdRows];
};

const hasNonEmptySubmoduleRowArray = (
  value: unknown
): value is Record<string, any>[] => Array.isArray(value) && value.length > 0;

/**
 * Resolve submodule rows for save from BindValue and name keys.
 * Empty arrays are treated as missing; when both keys have rows they are merged by id.
 */
export const resolveSubformRowsForSave = (
  formData: Record<string, any>,
  bindValue?: string,
  nameValue?: string
): Record<string, any>[] => {
  const bindRows = bindValue ? formData[bindValue] : undefined;
  const nameRows = nameValue ? formData[nameValue] : undefined;

  const bindHas = hasNonEmptySubmoduleRowArray(bindRows);
  const nameHas = hasNonEmptySubmoduleRowArray(nameRows);

  if (bindHas && nameHas && bindValue !== nameValue) {
    // Synced alias keys (e.g. jobcard_details + purchase_details) often share one array.
    if (bindRows === nameRows) return bindRows;
    return mergeSubmoduleRowsById(bindRows, nameRows);
  }
  if (bindHas) return bindRows;
  if (nameHas) return nameRows;
  if (Array.isArray(bindRows)) return bindRows;
  if (Array.isArray(nameRows)) return nameRows;
  return [];
};

const normSubformKey = (s: string | undefined | null) =>
  String(s || "")
    .trim()
    .toLowerCase();

/**
 * Merge API record over navigation/summary fallback without replacing good fallback
 * values with null/blank from the API (common on summary → edit flows).
 */
const mergeFallbackAndRecord = (
  fallback: Record<string, any> | null | undefined,
  record: Record<string, any> | null | undefined
): Record<string, any> => {
  const out: Record<string, any> = { ...(fallback || {}) };
  if (!record) return out;

  const isEmptyish = (v: any) =>
    v === undefined ||
    v === null ||
    (typeof v === "string" && v.trim() === "") ||
    // API often returns [] for child tables with no persisted rows yet; do not let that
    // wipe summary / navigation prefills (e.g. bank_reconciliation_voucher subform lines).
    (Array.isArray(v) && v.length === 0);

  for (const [k, v] of Object.entries(record)) {
    if (isEmptyish(v)) {
      if (isEmptyish(out[k])) {
        out[k] = v as any;
      }
    } else {
      out[k] = v;
    }
  }
  return out;
};

/** Map API `subform[]` child tables onto MULTI_SUB_LIST / MULTI_CHECKBOX BindValue fields for edit load. */
const hydrateSubformIntoMapped = (
  base: Record<string, any>,
  mapped: Record<string, any>,
  screenId: string | undefined
): void => {
  const subformArr = base?.subform;
  if (!Array.isArray(subformArr) || subformArr.length === 0) {
    return;
  }

  const targetScreenConfig =
    screenId && String(screenId).trim() !== ""
      ? getResolvedScreenConfig(screenId)
      : undefined;
  if (targetScreenConfig) {
    walkComponentTree(targetScreenConfig, (component) => {
    const ct = component.componentType;

    if (ct === ComponentType.MULTI_SUB_LIST) {
      const c = component as any;
      const bindValue = c.BindValue || c.name;
      const name = c.Name || c.name;
      const tableName = c.TableName || c.tableName;
      if (!bindValue || !bindValueIsMissingOrEmpty(mapped[bindValue])) {
        return false;
      }

      const match = subformArr.find((sf: any) => {
        const n = normSubformKey(sf?.name);
        const t = normSubformKey(sf?.tablename);
        return (
          (name && (n === normSubformKey(name) || t === normSubformKey(name))) ||
          (tableName &&
            (n === normSubformKey(tableName) || t === normSubformKey(tableName)))
        );
      });

      if (match && Array.isArray(match.data)) {
        mapped[bindValue] = match.data;
      } else {
        // Fallback: some APIs use e.g. service_checklist while screen config says vehicle_in_checklist
        const rowLooksLikeChecklist = (row: any) =>
          row &&
          typeof row === "object" &&
          (row.inspection_item !== undefined ||
            row.checked_a !== undefined ||
            row.sl_no !== undefined);
        const candidates = subformArr.filter(
          (sf: any) =>
            Array.isArray(sf?.data) &&
            sf.data.length > 0 &&
            sf.data.some(rowLooksLikeChecklist)
        );
        if (candidates.length === 1) {
          mapped[bindValue] = candidates[0].data;
        }
      }
      return false;
    }

    if (ct === ComponentType.MULTI_CHECKBOX) {
      const c = component as any;
      const bindValue = c.BindValue || c.name;
      const name = c.Name || c.name;
      const tableName = c.TableName || c.tableName;
      const jsonAttr = c.Json_Attribute || "work_requested_id";
      if (!bindValue || !bindValueIsMissingOrEmpty(mapped[bindValue])) {
        return false;
      }

      const match = subformArr.find((sf: any) => {
        const n = normSubformKey(sf?.name);
        const t = normSubformKey(sf?.tablename);
        return (
          (name && (n === normSubformKey(name) || t === normSubformKey(name))) ||
          (tableName &&
            (n === normSubformKey(tableName) || t === normSubformKey(tableName)))
        );
      });

      if (match && Array.isArray(match.data)) {
        // Keep full rows (persisted id + lookup id) like MULTI_SUB_LIST
        mapped[bindValue] = mapMultiCheckboxApiRowsToFormRows(match.data, jsonAttr);
      } else {
        const isWorkRequestedSubform = (sf: any): boolean => {
          if (!Array.isArray(sf?.data) || sf.data.length === 0) return false;
          const rows = sf.data.filter((r: any) => r && typeof r === "object");
          if (rows.length === 0) return false;
          const hasIdCol = rows.some(
            (r: any) => r[jsonAttr] !== undefined && r[jsonAttr] !== null && r[jsonAttr] !== ""
          );
          if (!hasIdCol) return false;
          return !rows.some(
            (r: any) =>
              r.inspection_item !== undefined ||
              r.checked_a !== undefined ||
              r.checked_b !== undefined
          );
        };
        const candidates = subformArr.filter(isWorkRequestedSubform);
        if (candidates.length === 1) {
          mapped[bindValue] = mapMultiCheckboxApiRowsToFormRows(
            candidates[0].data,
            jsonAttr
          );
        }
      }
      return false;
    }

    // SUB_MODULE: backend often returns rows under `subform` (e.g. bank_reconciliation_voucher prefill)
    // while the screen uses `subModule` + BindValue; without this, lines stay empty and a later
    // `/submodule/...` fetch by reminder id overwrites with [].
    if (ct === ComponentType.SUB_MODULE) {
      const c = component as any;
      const bindValue = c.BindValue || c.name;
      const name = c.Name || c.name;
      const tableName = c.TableName || c.tableName;
      if (!bindValue || !bindValueIsMissingOrEmpty(mapped[bindValue])) {
        return false;
      }

      const match = subformArr.find((sf: any) => {
        const n = normSubformKey(sf?.name);
        const t = normSubformKey(sf?.tablename);
        return (
          (name && (n === normSubformKey(name) || t === normSubformKey(name))) ||
          (tableName &&
            (n === normSubformKey(tableName) || t === normSubformKey(tableName))) ||
          (bindValue &&
            (n === normSubformKey(bindValue) || t === normSubformKey(bindValue)))
        );
      });

      if (match && Array.isArray(match.data) && match.data.length > 0) {
        const childControls = c.childControls;
        let mappedRows: Record<string, any>[];
        if (Array.isArray(childControls) && childControls.length > 0) {
          mappedRows = match.data.map((item: any) => {
            const row: Record<string, any> = { ...item };
            childControls.forEach((control: any) => {
              const fieldName = control.name || control.BindValue;
              const jsonAttr = control.Json_Attribute;
              if (!fieldName || !jsonAttr) return;
              let value =
                item[jsonAttr] ??
                item[jsonAttr?.toLowerCase?.()] ??
                item[jsonAttr?.toUpperCase?.()] ??
                item[jsonAttr?.replace?.(/_/g, "")];
              if (value === undefined && item[fieldName] !== undefined) {
                value = item[fieldName];
              }
              if (value !== undefined) {
                row[fieldName] = value;
              }
            });
            return row;
          });
        } else {
          mappedRows = match.data;
        }

        mapped[bindValue] = mappedRows;
        if (isCreditNoteInvoiceSplitSubmoduleConfig(c)) {
          const nameKey = c.name || c.Name;
          if (nameKey && nameKey !== bindValue) {
            mapped[nameKey] = mappedRows;
          }
        }
      }
      return false;
    }

    return false;
  });
  }

  // Always merge named subform blocks when mapped key is still empty (covers API-only config,
  // cache timing, or screens where walkComponentTree did not match).
  for (const sf of subformArr) {
    const keyRaw = sf?.name ?? sf?.tablename;
    if (keyRaw === undefined || keyRaw === null || String(keyRaw).trim() === "") {
      continue;
    }
    const mapKey = String(keyRaw);
    if (!Array.isArray(sf?.data) || sf.data.length === 0) {
      continue;
    }
    if (bindValueIsMissingOrEmpty(mapped[mapKey])) {
      mapped[mapKey] = sf.data;
    }
  }
};

export const buildFormDataFromRecord = (
  record: Record<string, any> | null | undefined,
  options: {
    fallback?: Record<string, any>;
    summaryComponent?: SummaryListComponent | null;
    screenId?: string;
  } = {}
): Record<string, any> => {
  const { fallback, summaryComponent, screenId } = options;

  const base: Record<string, any> = mergeFallbackAndRecord(fallback, record || undefined);

  // Bank recon (180): header fields are often nested under bank_reconciliation_voucher_details.
  const brDetails = base.bank_reconciliation_voucher_details;
  if (brDetails && typeof brDetails === "object" && !Array.isArray(brDetails)) {
    for (const [k, v] of Object.entries(brDetails)) {
      if (
        v !== undefined &&
        v !== null &&
        !(typeof v === "string" && v.trim() === "") &&
        bindValueIsMissingOrEmpty(base[k])
      ) {
        base[k] = v;
      }
    }
  }

  // Petty cash (32): header field group BindValue must not share the line-item key.
  for (const headerKey of [
    "petty_cash_voucher_header",
    "petty_cash_voucher_details",
  ]) {
    const headerBlock = base[headerKey];
    if (
      headerBlock &&
      typeof headerBlock === "object" &&
      !Array.isArray(headerBlock)
    ) {
      for (const [k, v] of Object.entries(headerBlock)) {
        if (
          v !== undefined &&
          v !== null &&
          !(typeof v === "string" && v.trim() === "") &&
          bindValueIsMissingOrEmpty(base[k])
        ) {
          base[k] = v;
        }
      }
    }
  }

  const mapped: Record<string, any> = {};

  // Helper function to find value in base with case-insensitive matching
  const findValueInBase = (searchKey: string): any => {
    // Special logging for estimation fields
    const isEstimationField = searchKey === "est_no" || searchKey === "est_date" ||
      searchKey === "txt_estimate_number" || searchKey === "dt_est_date";



    // Try exact match first
    if (base[searchKey] !== undefined && base[searchKey] !== null) {

      return base[searchKey];
    }

    // Try lowercase
    const lowerKey = searchKey.toLowerCase();
    if (base[lowerKey] !== undefined && base[lowerKey] !== null) {

      return base[lowerKey];
    }

    // Try case-insensitive search
    for (const [key, value] of Object.entries(base)) {
      if (
        key.toLowerCase() === lowerKey &&
        value !== undefined &&
        value !== null
      ) {

        return value;
      }
    }



    return undefined;
  };

  const collectAlternateBindKeys = (bindKey?: string, jsonKey?: string): string[] => {
    const keys: string[] = [];
    const add = (s?: string) => {
      if (!s) return;
      const t = String(s).trim();
      if (!t || keys.includes(t)) return;
      keys.push(t);
    };
    add(bindKey);
    add(jsonKey);
    if (jsonKey) {
      if (jsonKey === "pdc_transaction_type" || bindKey === "txt_pdc_transaction_type") {
        add("transaction_type");
      }
      if (jsonKey === "ref_date" || bindKey === "txt_reference_date") {
        add("reference_date");
      }
      if (jsonKey === "reference_date") {
        add("ref_date");
      }
      if (jsonKey === "ref_no" || bindKey === "txt_Ref_no") {
        add("txt_ref_no");
      }
      if (jsonKey === "cheque_no" || bindKey === "txt_cheque_no") {
        add("cheque_number");
        add("txt_cheque_number");
      }
      if (jsonKey === "cheque_number" || bindKey === "txt_cheque_number") {
        add("cheque_no");
        add("txt_cheque_no");
      }
      if (jsonKey === "narration" || bindKey === "txt_source_narration") {
        add("txt_narration");
        add("txt_remarks");
        add("remarks");
      }
      if (jsonKey === "total_debit" || bindKey === "txt_total_amount") {
        add("total_debit");
        add("txt_total_amount");
        add("total_credit");
      }
      if (jsonKey.startsWith("pdc_")) {
        add(jsonKey.slice(4));
      }
      if (jsonKey === "invoice_id" || bindKey === "drp_sales_ret") {
        add("invoice_id");
        add("drp_sales_ret");
      }
      if (jsonKey === "purchase_id" || bindKey === "drp_purchase_ret") {
        add("purchase_id");
        add("drp_purchase_ret");
      }
      if (jsonKey === "is_draft" || bindKey === "chk_add_to_unadjusted") {
        add("is_draft");
        add("chk_add_to_unadjusted");
      }
      if (jsonKey === "from_stock" || bindKey === "chk_from_stock") {
        add("from_stock");
        add("chk_from_stock");
      }
      if (
        jsonKey === "force_close_without_parts_issue" ||
        bindKey === "chk_force_close_without_parts_issue"
      ) {
        add("force_close_without_parts_issue");
        add("chk_force_close_without_parts_issue");
      }
    }
    return keys;
  };

  const findMappedValueForField = (bindKey?: string, jsonKey?: string): any => {
    for (const k of collectAlternateBindKeys(bindKey, jsonKey)) {
      const v = findValueInBase(k);
      if (v !== undefined && v !== null) {
        return v;
      }
    }
    return undefined;
  };

  // First, copy all base fields directly
  Object.entries(base).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      mapped[key] = value;
    }
  });

  // Then, map fields from summary component if available
  if (summaryComponent?.Form?.Fields) {
    summaryComponent.Form.Fields.forEach((field) => {
      const targetKey = field.BindValue;
      const sourceKey = field.Json_Attribute;

      if (!targetKey || !sourceKey) {
        return;
      }

      // Try to find value using both BindValue and Json_Attribute
      let value = findValueInBase(targetKey);
      if (value === undefined || value === null) {
        value = findValueInBase(sourceKey);
      }

      // Don't skip empty strings - they might be valid values
      if (value !== undefined && value !== null) {
        mapped[targetKey] = value;

      }
    });
  }

  // Finally, map fields from the target screen configuration
  if (screenId) {
    const targetScreenConfig = getResolvedScreenConfig(screenId);
    if (targetScreenConfig) {
      /** Map API/view columns to BindValue keys for HRMS profile layout (2217, etc.). */
      const normCompType = (t: any) =>
        String(t ?? "")
          .trim()
          .toLowerCase();

      const mapProfileBindFieldsFromRecord = (fields: any[] | undefined) => {
        if (!fields?.length) return;
        for (const field of fields) {
          const bindKey = field.BindValue || field.name;
          const jsonAttr = field.Json_Attribute ?? field.json_Attribute;
          let value: any;
          if (bindKey) {
            value = findValueInBase(bindKey);
          }
          if ((value === undefined || value === null) && jsonAttr) {
            value = findValueInBase(jsonAttr);
          }
          if (
            (value === undefined || value === null) &&
            jsonAttr &&
            typeof jsonAttr === "string"
          ) {
            if (!jsonAttr.includes("_")) {
              const snake = jsonAttr.replace(/([A-Z])/g, "_$1").toLowerCase();
              value = findValueInBase(snake);
            } else {
              const camel = jsonAttr
                .split("_")
                .map((w: string, i: number) =>
                  i === 0 ? w : w.charAt(0).toUpperCase() + w.slice(1)
                )
                .join("");
              value = findValueInBase(camel);
            }
          }
          if (value === undefined || value === null) {
            continue;
          }
          if (
            (normCompType(field.componentType) ===
              normCompType(ComponentType.DATE_FIELD) ||
              normCompType(field.componentType) ===
                normCompType(ComponentType.DATETIME_FIELD)) &&
            typeof value === "string"
          ) {
            const formatted = formatDateForInput(value);
            if (bindKey) mapped[bindKey] = formatted;
            if (field.name && field.name !== bindKey) {
              mapped[field.name] = formatted;
            }
            if (jsonAttr && jsonAttr !== bindKey) {
              mapped[jsonAttr] = formatted;
            }
          } else {
            if (bindKey) mapped[bindKey] = value;
            if (field.name && field.name !== bindKey) {
              mapped[field.name] = value;
            }
            if (
              jsonAttr &&
              jsonAttr !== bindKey &&
              jsonAttr !== field.name
            ) {
              mapped[jsonAttr] = value;
            }
          }
        }
      };

      // Walk through the target screen to find all form fields and map data
      walkComponentTree(targetScreenConfig, (component) => {
        // Handle FORM components with childComponents (new format)
        if (component.componentType === LayoutTypes.FORM) {
          const formComponent = component as any;
          // Handle childComponents (new format)
          if (
            formComponent.childComponents &&
            Array.isArray(formComponent.childComponents)
          ) {
            const mapFormLayoutField = (field: any) => {
              const fieldName = field.name || field.BindValue;
              const jsonAttr = field.Json_Attribute || field.json_Attribute;

              if (fieldName && jsonAttr) {
                let value = findMappedValueForField(fieldName, jsonAttr);

                // Special handling for Proforma Invoice discount:
                // When navigating from Estimate/QC Approve we may already have discount/txt_discount
                // in fallback/formData; if the API response doesn't provide a meaningful value,
                // preserve the existing one instead of overwriting with null/0.
                if (
                  (screenId === "175" || screenId === "116") &&
                  (fieldName === "txt_discount" || jsonAttr === "discount") &&
                  (value === undefined || value === null || value === "" || value === 0 || value === "0")
                ) {
                  const existing =
                    (fallback && (fallback as any).txt_discount) ??
                    (fallback && (fallback as any).discount);
                  if (existing !== undefined && existing !== null && existing !== "") {
                    value = existing;
                  }
                }

                // Jobcard (156) / Invoice (158 / 173): preserve round off prefill when API omits it.
                if (
                  (screenId === "156" || screenId === "158" || screenId === "173" || screenId === "175") &&
                  (fieldName === "txt_round_off" || jsonAttr === "round_off_amt") &&
                  (value === undefined || value === null || value === "")
                ) {
                  const existing =
                    (fallback && (fallback as any).txt_round_off) ??
                    (fallback && (fallback as any).round_off_amt) ??
                    (fallback as any)?.parentid1_selectedData?.round_off_amt ??
                    (fallback as any)?.parentid_selectedData?.round_off_amt;
                  if (existing !== undefined && existing !== null && existing !== "") {
                    value = existing;
                  }
                }

                // Special handling for workflow approve_status field (Estimate Approval edit workflow)
                // In some API responses, the workflow state may be exposed under different keys
                // like next_state, Next_State, status, etc. When editing an existing workflow
                // record, we want the approve_status dropdown to pre-populate with the saved state.
                if (
                  (fieldName === "approve_status" || jsonAttr === "approve_status") &&
                  (value === undefined || value === null || value === "")
                ) {
                  const candidateKeys = [
                    "approve_status",
                    "next_state",
                    "Next_State",
                    "nextState",
                    "current_state",
                    "Current_State",
                    "status",
                    "Status",
                  ];

                  for (const key of candidateKeys) {
                    const candidateValue = findValueInBase(key);
                    if (candidateValue !== undefined && candidateValue !== null && candidateValue !== "") {
                      value = candidateValue;
                      break;
                    }
                  }
                }

                // Special handling: For parent_id field in estimation forms, check inspection_id
                if ((value === undefined || value === null) &&
                  (jsonAttr === "parent_id" || isParentIdBindValue(fieldName))) {

                  // For Estimate Approval (150), prioritize 'id' (Estimate ID)
                  // We do this BEFORE checking inspection_id, because the Estimate record might HAVE an inspection_id,
                  // but for Screen 150 we want the Estimate's own ID as the parent.
                  if (screenId === "150") {
                    value = findValueInBase("id");
                    if (value === undefined || value === null) {
                      value = findValueInBase("estimation_id");
                    }
                  }

                  // Fallback to inspection_id (Standard behavior for Add Estimate screen 116)
                  if (value === undefined || value === null) {
                    value = findValueInBase("inspection_id");
                  }

                  // Generic fallback: If still null, try 'id' (Primary Key of source record)
                  if (value === undefined || value === null) {
                    value = findValueInBase("id");
                  }

                  if (value !== undefined && value !== null) {

                  }
                }

                // Also try snake_case version if jsonAttr is camelCase (API might use date_of_birth)
                if (
                  (value === undefined || value === null) &&
                  !jsonAttr.includes("_")
                ) {
                  // Convert camelCase to snake_case (e.g., dateOfBirth -> date_of_birth)
                  const snakeCaseAttr = jsonAttr
                    .replace(/([A-Z])/g, "_$1")
                    .toLowerCase();
                  value = findValueInBase(snakeCaseAttr);
                }
                // Try camelCase version if jsonAttr is snake_case (API might use dateOfBirth)
                if (
                  (value === undefined || value === null) &&
                  jsonAttr.includes("_")
                ) {
                  // Convert snake_case to camelCase (e.g., date_of_birth -> dateOfBirth)
                  const camelCaseAttr = jsonAttr
                    .split("_")
                    .map((word: string, i: number) =>
                      i === 0
                        ? word
                        : word.charAt(0).toUpperCase() + word.slice(1)
                    )
                    .join("");
                  value = findValueInBase(camelCaseAttr);
                }

                // Map the value to the form field name if found
                // Don't skip empty strings - they might be valid values
                if (value !== undefined && value !== null) {
                  // CRITICAL: Format DATE_FIELD values from backend format to input format
                  // Backend returns: "15-01-2024 10:30:00" (DD-MM-YYYY HH:mm:ss)
                  // Input needs: "2024-01-15T10:30" (YYYY-MM-DDTHH:mm) for datetime-local
                  // This matches Blazor's behavior where dates are formatted for input fields
                  if (
                    (field.componentType === ComponentType.DATE_FIELD ||
                      field.componentType === ComponentType.DATETIME_FIELD) &&
                    typeof value === "string"
                  ) {
                    const formattedDate = formatDateForInput(value);
                    mapped[fieldName] = formattedDate;
                    if (import.meta.env.DEV) {
                      // console.log(
                      //   `[buildFormDataFromRecord] ✓ Mapped DATE_FIELD ${jsonAttr} -> ${fieldName}:`,
                      //   { original: value, formatted: formattedDate }
                      // );
                    }
                  } else {
                    mapped[fieldName] = value;
                    // So file uploader (FILES) gets value in edit mode from either key
                    if (jsonAttr && jsonAttr !== fieldName) {
                      mapped[jsonAttr] = value;
                    }
                    if (import.meta.env.DEV) {
                      // console.log(
                      //   `[buildFormDataFromRecord] ✓ Mapped ${jsonAttr} -> ${fieldName}:`,
                      //   value
                      // );
                    }
                  }
                } else {
                  // Enhanced logging for missing fields, especially est_no and est_date
                  if (import.meta.env.DEV) {
                    const isEstimationField = jsonAttr === "est_no" || jsonAttr === "est_date" ||
                      fieldName === "txt_estimate_number" || fieldName === "dt_est_date";

                    if (isEstimationField) {
                      // console.warn(
                      //   `[buildFormDataFromRecord] ✗ MISSING Estimation Field: ${fieldName} (Json_Attribute: ${jsonAttr})`,
                      //   {
                      //     fieldName,
                      //     jsonAttr,
                      //     searchedKeys: [
                      //       fieldName,
                      //       jsonAttr,
                      //       jsonAttr.toLowerCase(),
                      //       jsonAttr.toUpperCase(),
                      //       ...(jsonAttr.includes("_") ? [jsonAttr.split("_").map((w: string, i: number) =>
                      //         i === 0 ? w : w.charAt(0).toUpperCase() + w.slice(1)
                      //       ).join("")] : []),
                      //       ...(!jsonAttr.includes("_") ? [jsonAttr.replace(/([A-Z])/g, "_$1").toLowerCase()] : []),
                      //     ],
                      //     availableKeys: Object.keys(base).filter(k =>
                      //       k.toLowerCase().includes("est") ||
                      //       k.toLowerCase().includes("estimate")
                      //     ),
                      //     sampleBaseData: Object.keys(base).slice(0, 30).reduce((acc, k) => {
                      //       acc[k] = base[k];
                      //       return acc;
                      //     }, {} as Record<string, any>),
                      //   }
                      // );
                    } else {
                      // console.log(
                      //   `[buildFormDataFromRecord] Could not find value for ${fieldName} (Json_Attribute: ${jsonAttr})`
                      // );
                    }
                  }
                }
              } else if (fieldName) {
                const value = findMappedValueForField(fieldName, jsonAttr);
                if (value !== undefined && value !== null) {
                  mapped[fieldName] = value;
                }
              }
            };

            formComponent.childComponents.forEach((field: any) => {
              if (
                field.childComponents &&
                Array.isArray(field.childComponents)
              ) {
                field.childComponents.forEach(mapFormLayoutField);
              } else {
                mapFormLayoutField(field);
              }
            });
          }

          // Handle FORM components with Fields array (old format)
          const formFields = (component as any).Fields;
          if (formFields && Array.isArray(formFields)) {
            formFields.forEach((field: any) => {
              const fieldType = String(field.componentType || "").toLowerCase();
              if (fieldType === "submodule") {
                const footerControls =
                  field.FooterControls || field.footerControls || [];
                footerControls.forEach((footerField: any) => {
                  const bindValue = footerField.BindValue;
                  const jsonAttr =
                    footerField.Json_Attribute || footerField.json_Attribute;
                  if (!bindValue || !jsonAttr) return;
                  const value = findMappedValueForField(bindValue, jsonAttr);
                  if (value !== undefined && value !== null) {
                    mapped[bindValue] = value;
                    if (jsonAttr !== bindValue) {
                      mapped[jsonAttr] = value;
                    }
                  }
                });
              }

              // Handle nested childComponents recursively (e.g. FIELD_GROUP → FIELD_GROUP → CHECKBOX)
              if (
                field.childComponents &&
                Array.isArray(field.childComponents)
              ) {
                walkAndMapChildFields(field.childComponents, mapped, {
                  findMappedValueForField,
                  findValueInBase,
                  screenId,
                });
              }

              // Handle direct fields in Fields array (e.g., TEXT_FIELD, DATE_FIELD directly in Fields)
              const bindValue = field.BindValue;
              const jsonAttr = field.Json_Attribute;
              if (bindValue && jsonAttr && field.componentType) {
                let value = findMappedValueForField(bindValue, jsonAttr);
                // Don't skip empty strings - they might be valid values
                if (value !== undefined && value !== null) {
                  mapped[bindValue] = value;
                  if (import.meta.env.DEV) {
                    // console.log(
                    //   `[buildFormDataFromRecord] Mapped direct field ${jsonAttr} -> ${bindValue}:`,
                    //   value
                    // );
                  }
                } else if (import.meta.env.DEV) {
                  // console.log(
                  //   `[buildFormDataFromRecord] Could not find value for direct field ${bindValue} (Json_Attribute: ${jsonAttr})`
                  // );
                }
              }
            });
          }
        }

        // HRMS read-only profile (2217): PROFILE_* components keep fields on `fields`
        // or under PROFILE_TABS.config.tabConfigs — not FORM / profileForm layout.
        const layoutComp = normCompType(component.componentType);
        if (layoutComp === normCompType(ComponentType.PROFILE_HEADER_CARD)) {
          mapProfileBindFieldsFromRecord((component as any).fields);
        }
        if (layoutComp === normCompType(ComponentType.PROFILE_CONTACT_INFO)) {
          mapProfileBindFieldsFromRecord((component as any).fields);
        }
        if (layoutComp === normCompType(ComponentType.PROFILE_DEPARTMENT_INFO)) {
          mapProfileBindFieldsFromRecord((component as any).fields);
        }
        if (layoutComp === normCompType(ComponentType.PROFILE_TABS)) {
          const tabConfigs = (component as any).config?.tabConfigs;
          if (tabConfigs && typeof tabConfigs === "object") {
            for (const tabConfig of Object.values(tabConfigs) as any[]) {
              const sections: any[] = tabConfig?.sections || [];
              for (const section of sections) {
                mapProfileBindFieldsFromRecord(section?.fields);
              }
            }
          }
        }

        // Handle CUSTOM profileForm components (HRMS Employee Profile Add).
        // These store their fields inside props.tabConfigs -> sections -> fields
        // instead of a standard FORM layout, so we must walk them explicitly.
        if (
          component.componentType === ComponentType.CUSTOM &&
          (component as any).customType === "profileForm"
        ) {
          const tabConfigs = (component as any).props?.tabConfigs;
          if (tabConfigs && typeof tabConfigs === "object") {
            Object.values(tabConfigs).forEach((tabConfig: any) => {
              const sections: any[] = tabConfig?.sections || [];
              sections.forEach((section: any) => {
                const fields: any[] = section?.fields || [];
                fields.forEach((field: any) => {
                  const fieldName = field.name || field.BindValue;
                  const jsonAttr = field.Json_Attribute || field.json_Attribute;
                  if (!fieldName || !jsonAttr) return;

                  // Prefer the BindValue key first, then fall back to Json_Attribute
                  let value = findValueInBase(fieldName);
                  if (value === undefined || value === null) {
                    value = findValueInBase(jsonAttr);
                  }

                  if (value !== undefined && value !== null) {
                    // Store raw value; DateField component handles its own format conversion
                    // (it accepts YYYY-MM-DD, DD-MM-YYYY, DD/MM/YYYY, ISO timestamp, etc.)
                    mapped[fieldName] = value;
                  }
                });
              });
            });
          }
        }

        return false;
      });
    }

    // Also collect field names as before for backward compatibility
    const fieldNames = collectFieldNamesForScreen(screenId);
    fieldNames.forEach((fieldName) => {
      // Try to find value using field name
      let value = findValueInBase(fieldName);

      // If not found, try to find by Json_Attribute
      if ((value === undefined || value === null) && targetScreenConfig) {
        walkComponentTree(targetScreenConfig, (component) => {
          if (component.componentType === LayoutTypes.FORM) {
            const formComponent = component as any;
            if (
              formComponent.childComponents &&
              Array.isArray(formComponent.childComponents)
            ) {
              const field = formComponent.childComponents.find(
                (f: any) => (f.name || f.BindValue) === fieldName
              );
              if (field) {
                const jsonAttr = field.Json_Attribute || field.json_Attribute;
                if (jsonAttr) {
                  value = findValueInBase(jsonAttr);
                  return true; // Stop searching
                }
              }
            }
          }
          return false;
        });
      }

      if (value !== undefined && value !== null) {
        mapped[fieldName] = value;
        if (import.meta.env.DEV) {
          // console.log(
          //   `[buildFormDataFromRecord] Field name mapping: ${fieldName}:`,
          //   value
          // );
        }
      }
    });
  }

  // if (import.meta.env.DEV) {
  //   console.log("[buildFormDataFromRecord] ===== Field Mapping Summary =====");
  //   console.log("[buildFormDataFromRecord] Base data keys:", Object.keys(base || {}));
  //   console.log("[buildFormDataFromRecord] Mapped data keys:", Object.keys(mapped));
  //   console.log("[buildFormDataFromRecord] Mapped fields count:", Object.keys(mapped).length);
  //   console.log("[buildFormDataFromRecord] Sample mapped values:",
  //     Object.keys(mapped).slice(0, 9999).reduce((acc, key) => {
  //       const value = mapped[key];
  //       acc[key] = Array.isArray(value)
  //         ? `[Array(${value.length})]`
  //         : typeof value === 'object' && value !== null
  //           ? '[Object]'
  //           : value;
  //       return acc;
  //     }, {} as Record<string, any>)
  //   );
  //   console.log("[buildFormDataFromRecord] Full mapped data:", mapped);
  //   console.log("[buildFormDataFromRecord] Full base data:", base);
  //   console.log("[buildFormDataFromRecord] ==================================");
  // }

  hydrateSubformIntoMapped(base, mapped, screenId);

  return mapped;
};

/**
 * Gets parent ID from formData by checking multiple field name variations.
 * Handles common patterns like parentid, parent_id, inspection_id, etc.
 * 
 * @param formData - The form data object to search in
 * @param parentField - The parent field name to look for (e.g., "parentid")
 * @returns The parent ID value if found, null otherwise
 */
export const getParentIdFromFormData = (
  formData: Record<string, any>,
  parentField: string | undefined
): string | number | null => {
  if (!formData) return null;

  // If parentField is provided, try direct match first
  if (parentField && formData[parentField] !== undefined && formData[parentField] !== null && formData[parentField] !== "") {
    return formData[parentField];
  }

  // Customer/supplier dropdowns often store Json_Attribute separately from BindValue
  if (parentField === "drp_customer") {
    const customerId = getCaseInsensitiveValue(formData, "customer_id");
    if (customerId !== undefined && customerId !== null && customerId !== "") {
      return customerId;
    }
  }
  if (parentField === "drp_supplier") {
    const supplierId = getCaseInsensitiveValue(formData, "supplier_id");
    if (supplierId !== undefined && supplierId !== null && supplierId !== "") {
      return supplierId;
    }
  }

  // Pending purchase parts: only job card id from lines — never purchase record id.
  if (parentField === "job_card_id_selected") {
    const purchaseRecordId = String(formData.id ?? formData.purchase_id ?? "").trim();
    const selected = formData.job_card_id_selected ?? formData.job_card_id;
    if (
      selected !== undefined &&
      selected !== null &&
      String(selected).trim() !== "" &&
      (!purchaseRecordId || String(selected).trim() !== purchaseRecordId)
    ) {
      return selected;
    }
    for (const key of ["jobcard_details", "purchase_details", "job_card_details"]) {
      const rows = formData[key];
      if (!Array.isArray(rows)) continue;
      for (const row of rows) {
        if (!row || typeof row !== "object") continue;
        const jc = (row as Record<string, unknown>).job_card_id_item ??
          (row as Record<string, unknown>).job_card_id;
        if (
          jc !== undefined &&
          jc !== null &&
          String(jc).trim() !== "" &&
          (!purchaseRecordId || String(jc).trim() !== purchaseRecordId)
        ) {
          return jc as string | number;
        }
      }
    }
    return null;
  }

  // Common keys for parent IDs in different modules
  const keysToTry = [
    "parentid",
    "parentid1",
    "parent_id",
    "parentId",
    "inspection_id",
    "inspectionId",
    "jobcard_id",
    "jobcardId",
    "estimate_id",
    "estimateId",
    "id", // Fallback to id if it's the primary record id
  ];

  // If parentField is available, add variations of it
  if (parentField) {
    keysToTry.unshift(
      `${parentField}_id`,
      `${parentField}Id`,
      parentField
    );
  }

  // Try each key case-insensitively
  for (const key of keysToTry) {
    const value = getCaseInsensitiveValue(formData, key);
    if (value !== undefined && value !== null && value !== "") {
      return value;
    }
  }

  // Final fallback: search all keys for something ending in _id or id
  const idKey = Object.keys(formData).find(k => {
    const kl = k.toLowerCase();
    return kl !== "id" && (kl.endsWith("_id") || kl.endsWith("id")) &&
      !kl.includes("created") && !kl.includes("updated") && !kl.includes("user") && !kl.includes("emp");
  });

  if (idKey && formData[idKey] !== undefined && formData[idKey] !== null && formData[idKey] !== "") {
    return formData[idKey];
  }

  return null;
};

/**
 * Gets parent ID description from formData by checking multiple field name variations.
 */
export const getParentIdDescFromFormData = (
  formData: Record<string, any>,
  parentField: string | undefined
): string => {
  if (!formData) return "";

  const keysToTry = [
    "parent_id_desc",
    "parentid_desc",
    "parentIdDesc",
    "inspection_no",
    "inspectionNo",
    "jobcard_no",
    "jobcardNo",
    "estimate_no",
    "estimateNo",
    "parent_name",
    "parentName",
  ];

  if (parentField) {
    keysToTry.unshift(
      `${parentField}_desc`,
      `${parentField}Desc`,
      `${parentField}_name`,
      `${parentField}Name`
    );
  }

  for (const key of keysToTry) {
    const value = getCaseInsensitiveValue(formData, key);
    if (value !== undefined && value !== null && value !== "") {
      return String(value);
    }
  }

  // Try to find selectedData description
  const selectedData =
    (parentField ? formData[`${parentField}_selectedData`] : null) ||
    formData.parentid1_selectedData ||
    formData.parentid_selectedData ||
    formData.parent_id_selectedData;
  if (selectedData && typeof selectedData === 'object') {
    return (selectedData as any).name || (selectedData as any).label || (selectedData as any).estimation_no || (selectedData as any).inspection_no || "";
  }

  return "";
};

/** Label text for customer type from a jobcard/invoice row (visibility + dropdown _selectedData). */
export const getCustomerTypeLabelFromRecord = (
  record: Record<string, unknown> | null | undefined
): string => {
  if (!record) return "";
  const label =
    record.customertype_desc ??
    record.customer_type_desc ??
    record.customer_type_name ??
    record.customertype_name;
  if (label != null && String(label).trim() !== "") return String(label);
  const fallback = record.customertype ?? record.customer_type;
  if (
    fallback != null &&
    typeof fallback === "string" &&
    Number.isNaN(Number(fallback))
  ) {
    return String(fallback);
  }
  return "";
};

/** Resolve the display label for customer type from lookup id, selectedData, or jobcard. */
export const resolveCustomerTypeLabel = (
  refField: string,
  formData: Record<string, unknown>,
  lookups?: Record<
    string,
    Array<{ value?: unknown; id?: unknown; label?: string; name?: string }>
  >
): string => {
  const rawValue = formData[refField];
  if (lookups && rawValue != null && rawValue !== "") {
    const lookupKeys = [
      "customer_type",
      ...Object.keys(lookups).filter((key) => key.startsWith("customer_type_")),
    ];
    for (const key of lookupKeys) {
      const options = lookups[key];
      if (!Array.isArray(options)) continue;
      const match = options.find(
        (opt) =>
          String(opt.value ?? "") === String(rawValue) ||
          String(opt.id ?? "") === String(rawValue)
      );
      if (match) {
        return String(match.label ?? match.name ?? "");
      }
    }
  }

  const selectedData = formData[`${refField}_selectedData`] as
    | Record<string, unknown>
    | undefined;
  if (selectedData) {
    const fromSelected = String(
      selectedData.name ?? selectedData.label ?? selectedData.value ?? ""
    ).trim();
    if (fromSelected) return fromSelected;
  }

  const parent = (formData.parentid1_selectedData ??
    formData.parentid_selectedData ??
    formData.parent_id_selectedData) as Record<string, unknown> | undefined;
  return getCustomerTypeLabelFromRecord(parent);
};

export const buildLookupSelectedData = (
  value: unknown,
  label?: string
): Record<string, string> | null => {
  if (value === undefined || value === null || value === "") return null;
  const strValue = String(value);
  const strLabel =
    label != null && String(label).trim() !== "" ? String(label).trim() : strValue;
  return { value: strValue, id: strValue, name: strLabel, label: strLabel };
};

/** Whether a fieldVisibilityRules "when" condition matches current form data. */
const normalizeModeLabelForMatch = (value: string): string =>
  value.toLowerCase().replace(/\s+/g, " ").trim();

const compactModeLabelForMatch = (value: string): string =>
  value.toLowerCase().replace(/[\s_-]+/g, "");

const modeLabelsMatch = (selected: string, required: string): boolean => {
  const sel = normalizeModeLabelForMatch(selected);
  const req = normalizeModeLabelForMatch(required);
  if (!sel || !req) return false;
  if (sel.includes(req) || req.includes(sel)) return true;
  const selCompact = compactModeLabelForMatch(selected);
  const reqCompact = compactModeLabelForMatch(required);
  return (
    (selCompact.length > 0 &&
      reqCompact.length > 0 &&
      (selCompact.includes(reqCompact) || reqCompact.includes(selCompact))) ||
    false
  );
};

export const matchesFieldVisibilityRule = (
  refField: string,
  requiredLabel: string,
  formData: Record<string, unknown>,
  lookups?: Record<
    string,
    Array<{ value?: unknown; id?: unknown; label?: string; name?: string }>
  >
): boolean => {
  const req = String(requiredLabel).toLowerCase();
  const selectedData = formData[`${refField}_selectedData`] as
    | Record<string, unknown>
    | undefined;
  const rawValue = formData[refField];

  const isCustomerTypeField =
    refField === "s_select_customertype" || refField === "s_select_customertype_";
  if (isCustomerTypeField) {
    const resolvedLabel = resolveCustomerTypeLabel(refField, formData, lookups);
    if (resolvedLabel) {
      return modeLabelsMatch(resolvedLabel, requiredLabel);
    }
    return false;
  }

  const selectedLabel =
    selectedData != null
      ? String(
          selectedData.name ?? selectedData.label ?? selectedData.value ?? ""
        ).toLowerCase()
      : "";
  const rawStr = rawValue != null ? String(rawValue).toLowerCase() : "";
  if (modeLabelsMatch(selectedLabel, req) || modeLabelsMatch(rawStr, req)) return true;

  // Bill mode / other lookups: value is often an id — resolve label from cached options
  if (lookups && rawValue != null && rawValue !== "") {
    const billModeKeys = ["billmodes_from_ledger", "billmodes"];
    const keysToSearch =
      refField === "drp_billmode" || refField.includes("billmode")
        ? billModeKeys
        : Object.keys(lookups);
    for (const key of keysToSearch) {
      const options = lookups[key];
      if (!Array.isArray(options)) continue;
      const match = options.find(
        (opt) =>
          String(opt.value ?? "") === String(rawValue) ||
          String(opt.id ?? "") === String(rawValue)
      );
      if (match) {
        const optLabel = String(match.label ?? match.name ?? "");
        if (modeLabelsMatch(optLabel, requiredLabel)) return true;
      }
    }
  }

  return false;
};

export const isFieldVisibleByVisibilityRules = (
  fieldName: string,
  rules: FieldVisibilityRule[] | undefined | null,
  formData: Record<string, unknown>,
  lookups?: Record<
    string,
    Array<{ value?: unknown; id?: unknown; label?: string; name?: string }>
  >
): boolean => {
  if (!rules || rules.length === 0) return true;
  const matchingRules = rules.filter((r) => r.showFields?.includes(fieldName));
  if (matchingRules.length === 0) return true;
  return matchingRules.some((r) =>
    matchesFieldVisibilityRule(r.when.field, r.when.label, formData, lookups)
  );
};

/** Skip subforms listed in fieldVisibilityRules when their driving condition is not active. */
export const isSubformIncludedInSave = (
  subformConfig: {
    name?: string;
    Name?: string;
    BindValue?: string;
  },
  rules: FieldVisibilityRule[] | undefined | null,
  formData: Record<string, unknown>,
  lookups?: Record<
    string,
    Array<{ value?: unknown; id?: unknown; label?: string; name?: string }>
  >
): boolean => {
  const identifiers = [
    subformConfig.name,
    subformConfig.Name,
    subformConfig.BindValue,
  ].filter((value): value is string => typeof value === "string" && value.trim() !== "");

  if (!rules?.length || identifiers.length === 0) return true;

  const controlledIdentifiers = identifiers.filter((identifier) =>
    rules.some((rule) => rule.showFields?.includes(identifier))
  );
  if (controlledIdentifiers.length === 0) return true;

  return controlledIdentifiers.some((identifier) =>
    isFieldVisibleByVisibilityRules(identifier, rules, formData, lookups)
  );
};

export const getFieldLabelFromVisibilityRules = (
  fieldName: string,
  rules: FieldVisibilityRule[] | undefined | null,
  formData: Record<string, unknown>,
  lookups?: Record<
    string,
    Array<{ value?: unknown; id?: unknown; label?: string; name?: string }>
  >
): string | undefined => {
  if (!rules || rules.length === 0) return undefined;
  for (const rule of rules) {
    if (!rule.showFields?.includes(fieldName)) continue;
    if (
      !matchesFieldVisibilityRule(
        rule.when.field,
        rule.when.label,
        formData,
        lookups
      )
    ) {
      continue;
    }
    const override = rule.fieldLabels?.[fieldName];
    if (override != null && String(override).trim() !== "") {
      return String(override);
    }
  }
  return undefined;
};

export const deriveScreenId = (view: string): string | undefined => {
  if (!view) return undefined;

  // Handle slash-separated paths (e.g., "151/6" or "modulev1/vehiclemake/6")
  const parts = view.split("/");
  const baseView = parts[0];

  if (screenConfigRegistry[view]) {
    return view;
  }

  if (screenConfigRegistry[baseView]) {
    return baseView;
  }

  if (viewToScreenIdMap[view]) {
    return viewToScreenIdMap[view];
  }

  if (viewToScreenIdMap[baseView]) {
    return viewToScreenIdMap[baseView];
  }

  // Handle full URLs dynamically by checking if valid map keys are contained in the view string
  // This allows matching URLs like ".../screen/vehiclemake" to "screen/vehiclemake" without hardcoding domains
  const dynamicMatch = Object.keys(viewToScreenIdMap).find(
    (key) => key.includes("/") && view.endsWith(key)
  );
  if (dynamicMatch) {
    return viewToScreenIdMap[dynamicMatch];
  }

  // Also check if any part of the path matches a screen ID
  for (const part of parts) {
    if (screenConfigRegistry[part]) {
      return part;
    }
  }

  return undefined;
};

/**
 * For job card add view (e.g. modulev1/jobcard_add/{id}), returns the id segment
 * so SubModule/Report and App can use it as parentid (estimation id).
 */
export const getRecordIdFromView = (view: string): string | null => {
  if (!view || typeof view !== "string") return null;
  const parts = view.split("/").filter(Boolean);
  if (!view.includes("jobcard_add") || parts.length < 2) return null;
  const last = parts[parts.length - 1];
  if (!last || last === "jobcard_add" || last.includes("<") || last.includes(">")) return null;
  return last;
};

const getCaseInsensitiveValue = (
  source: Record<string, any> | null | undefined,
  targetKey: string
) => {
  if (!source || typeof source !== "object") {
    return undefined;
  }

  const normalizedTarget = targetKey.toLowerCase();

  for (const [key, value] of Object.entries(source)) {
    if (key.toLowerCase() === normalizedTarget) {
      return value;
    }
  }

  return undefined;
};

const extractNavigatePlaceholders = (navigatePath?: string): string[] => {
  if (!navigatePath || typeof navigatePath !== "string") {
    return [];
  }

  const keys: string[] = [];

  const placeholderRegex = /<([^>]+)>/g;
  let match: RegExpExecArray | null;

  while ((match = placeholderRegex.exec(navigatePath)) !== null) {
    const rawKey = match[1]?.trim();
    if (rawKey) {
      keys.push(rawKey);
    }
  }

  return keys;
};

const shouldIgnoreIdKey = (key: string) => {
  const lower = key.toLowerCase();
  return (
    lower.includes("customer") ||
    lower.includes("created") ||
    lower.includes("updated") ||
    lower.includes("deleted")
  );
};

/** Summary-list ActionTypes that POST to `/pabws/module/{Module}/{actionType}` (or `Action.Api`). */
export const SUMMARY_LIST_API_ACTION_TYPES = new Set(["request", "authorize"]);

/**
 * Resolve POST endpoint for a summary action from screen JSON (`Action.Module` or `Action.Api`).
 * No hardcoded module names in thunks — configure on the screen.
 */
export const resolveSummaryListApiEndpoint = (
  summaryAction: SummaryListActionConfig | undefined,
  actionTypeLower: string
): string | undefined => {
  if (!summaryAction?.Action || !SUMMARY_LIST_API_ACTION_TYPES.has(actionTypeLower)) {
    return undefined;
  }
  const action = summaryAction.Action as Record<string, string | undefined>;
  const explicit = action.Api || action.api || action.Endpoint || action.endpoint;
  if (explicit?.trim()) {
    const trimmed = explicit.trim();
    if (trimmed.startsWith("/pabws/")) {
      return trimmed;
    }
    if (trimmed.startsWith("/")) {
      return `/pabws${trimmed}`;
    }
    return `/pabws/${trimmed.replace(/^\/+/, "")}`;
  }
  const moduleName =
    action.Module || action.module || action.ModuleName || action.modulename;
  if (moduleName?.trim()) {
    return `/pabws/module/${moduleName.trim()}/${actionTypeLower}`;
  }
  return undefined;
};

export const deriveRecordIdFromRow = (
  row: Record<string, any> | null | undefined,
  options: { summaryAction?: SummaryListActionConfig } = {}
): string | number | undefined => {
  if (!row || typeof row !== "object") {
    return undefined;
  }

  const keysToCheck: string[] = [];
  const seen = new Set<string>();

  const enqueueKey = (key?: string | null) => {
    if (!key) {
      return;
    }
    const trimmed = key.trim();
    if (!trimmed) {
      return;
    }
    const lower = trimmed.toLowerCase();
    if (seen.has(lower)) {
      return;
    }
    seen.add(lower);
    keysToCheck.push(trimmed);
  };

  // CRITICAL: Check for __workflowChildId first (passed from DataTable for workflow actions)
  enqueueKey("__workflowChildId");

  const navigatePath =
    options.summaryAction?.Action?.Navigate ||
    options.summaryAction?.Action?.navigate;
  extractNavigatePlaceholders(navigatePath).forEach(enqueueKey);

  enqueueKey(
    options.summaryAction?.Action?.RecordIdKey ||
    options.summaryAction?.Action?.recordIdKey ||
    options.summaryAction?.Action?.RecordID ||
    options.summaryAction?.Action?.recordID
  );

  const idLikeKeys = Object.keys(row).filter((key) => {
    const lower = key.toLowerCase();
    if (shouldIgnoreIdKey(lower)) {
      return false;
    }
    return lower === "id" || lower.endsWith("_id") || lower.endsWith("id");
  });

  const keyWeight = (key: string) => {
    const lower = key.toLowerCase();
    if (lower === "id") return 0;
    if (lower.endsWith("_id")) return 1;
    if (lower.endsWith("id")) return 2;
    return 3;
  };

  idLikeKeys
    .sort((a, b) => keyWeight(a) - keyWeight(b))
    .forEach((key) => enqueueKey(key));

  for (const key of keysToCheck) {
    const value = getCaseInsensitiveValue(row, key);
    if (value !== undefined && value !== null && value !== "") {
      return value as string | number;
    }
  }

  return undefined;
};

export const extractDrawerMenu = (): DrawerMenuConfig | undefined => {
  const screenGroup = screen_100_home[0] as ScreenGroupComponent;
  return screenGroup.drawerMenu;
};

export const resolveView = (view: string) => view;

export const loadEncryptedUserData = () =>
  localStorage.getItem("encryptedUserData");

export const decryptUserData = (encrypted: string) =>
  authService.decryptData(encrypted);

export const fetchScreenData = (screenId: string) =>
  apiService.get(
    "/pabws/screens/get_screens_with_id",
    { screenid: screenId },
    {
      errorHandling: "throw",
      transformResponse: (data: any) => {
        if (data) {
          if (data.data) {
            return Array.isArray(data.data) ? data.data[0] : data.data;
          } else if (Array.isArray(data)) {
            return data[0];
          }
          return data;
        }
        return null;
      },
    }
  );
